import React, { useState, useEffect, useContext } from "react";
import {
  CheckCircle,
  Plus,
  Trash2,
  Search,
  Calendar as CalendarIcon,
  Users,
  Clock,
  MapPin,
  AlertCircle,
  TrendingUp,

  Activity,
  GraduationCap,
  UserCheck,
  Briefcase,
  Coffee,
  FileText,
  Download,
  Sun,
  Globe,
  CalendarDays,
  Target,
  Timer,
  Facebook,
  Twitter,
  Linkedin,
  MessageCircle,
  Mail,
  Share2,
  Copy,
  Settings,
  ChevronLeft,
  ChevronRight,
  Zap,
  X,
  Check,
} from "lucide-react";
import { ThemeContext } from "./theme";
import { LanguageContext } from "./LanguageContext";
import ReusableDropdown, { unifiedControlStyle } from "../components/ReusableDropdown";
import { apiFetch } from "../context/AuthContext";
import { useProfile } from "../hooks/useProfile";
const translations = {
  en: {
    // Calendar Header
    calendar: "Calendar",
    advancedScheduling: "Advanced scheduling system with smart event management, vacation planning, productivity insights, and analytics",
    newEvent: "New Event",
    new: "New",
    share: "Share",

    // Statistics
    totalEvents: "Total Events",
    thisMonth: "This Month",
    todayEvents: "Today's Events",
    thisWeek: "This Week",
    upcoming: "Upcoming",
    completed: "Completed",
    overdue: "Overdue",
    weeklyHours: "Weekly Hours",
    meetings: "Meetings",
    deadlines: "Deadlines",
    vacationDays: "Vacation Days",
    productivity: "Productivity",
    fromLastMonth: "From last month",

    // To-Do List
    todoList: "To-Do List",
    addNewTask: "Add New Task",
    typeTaskHere: "Type your task here...",
    addTask: "Add Task",
    allTasks: "All Tasks",
    activeTasks: "Active",
    completedTasks: "Completed",
    noTasks: "No Tasks Yet",
    noTasksDescription: "Start adding tasks to stay organized",
    markComplete: "Mark Complete",
    deleteTask: "Delete Task",
    personalTasks: "Personal",
    workTasks: "Work",
    urgentTasks: "Urgent",
    taskProgress: "Progress",
    of: "of",
    tasksCompleted: "tasks completed",
    category: "Category",
    taskDescription: "Task Description",

    // Calendar Controls
    calendarControls: "Calendar Controls",
    searchEvents: "Search events...",

    // Event Types
    allEvents: "All Events",
    training: "Training",
    interviews: "Interviews",
    reviews: "Reviews",
    social: "Social",
    deadline: "Deadline",
    vacation: "Vacation",
    conferences: "Conferences",
    eventCategories: "Event Categories",

    // Upcoming Events
    upcomingEvents: "Upcoming Events",
    noUpcomingEvents: "No upcoming events",
    calendarClear: "Your calendar is clear for the coming week",

    // Quick Actions
    quickActions: "Quick Actions",
    shareCalendar: "Share Calendar",
    exportCalendar: "Export Calendar",

    // Event Modal
    createNewEvent: "Create New Event",
    editEvent: "Edit Event",
    viewEventDetails: "View Event Details",
    eventOrganizedBy: "Event organized by",
    updateEventDetails: "Update event details and settings",
    addNewEvent: "Add new",
    toYourCalendar: "to your calendar",
    organizedBy: "Organized by",
    youAreAttendee: "You are an attendee of this event",
    yourCurrentRSVP: "Your current RSVP",
    noResponse: "No response",
    updateResponse: "Use the buttons below to update your response",

    // Event Form Fields
    eventTitle: "Event Title",
    enterEventTitle: "Enter",
    title: "title",
    description: "Description",
    addVacationNotes: "Add vacation notes, contact info, or special instructions...",
    addProjectDetails: "Add project details, requirements, or delivery guidance...",
    addDetailedDescription: "Add a detailed description, agenda, notes, or meeting objectives...",

    // Date & Time
    startDate: "Start Date",
    date: "Date",
    endDate: "End Date",
    lastDayVacation: "Last day of vacation",
    extendedDeadline: "Extended deadline (optional)",
    multiDayEnd: "Multi-day event end date",
    startTime: "Start Time",
    dueTime: "Due Time",
    duration: "Duration",
    minutes: "Minutes",
    minute: "Minute",
    hour: "Hour",
    hours: "Hours",
    allDay: "All Day",
    endDateEarlier: "End date cannot be before start date. Please choose a valid end date.",

    // Event Properties
    eventType: "Event Type",
    priority: "Priority",
    lowPriority: "Low Priority",
    mediumPriority: "Medium Priority",
    highPriority: "High Priority",
    urgent: "Urgent",
    status: "Status",
    yourStatus: "Your Status",
    accepted: "Accepted",
    declined: "Declined",
    tentative: "Tentative",
    scheduled: "Scheduled",
    confirmed: "Confirmed",
    inProgress: "In Progress",
    cancelled: "Cancelled",
    postponed: "Postponed",

    // Location
    venue: "Venue",
    meetingLocation: "Meeting Location",
    location: "Location",
    conferenceVenue: "Conference center or venue name or address...",
    meetingRoom: "Meeting room or link or office location...",
    locationDetails: "Location details or address or link...",

    // Attendees
    eventAttendees: "Event Attendees",
    attendees: "Attendees",
    organizer: "Organizer",
    typeNameEmail: "Type name or email to search employees, or enter emails separated by commas",
    searchingFor: "Searching for",
    found: "found",
    availableEmployees: "Available Employees",
    loadingDirectory: "Loading employee directory...",
    noEmployeesFound: "No employees found for",
    typeEmailManually: "You can type email addresses manually",
    attendeesPlural: "attendees",
    attendee: "attendee",
    willReceiveInvitations: "will receive invitations",
    employeesAvailable: "employees available in directory",

    // Recurrence
    recurrence: "Recurrence (optional)",
    noRecurrence: "No recurrence",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    yearly: "Yearly",

    // Reminders
    enableReminders: "Enable reminders",
    reminders: "Reminders & Notifications",
    emailRemindersEnabled: "Email reminders enabled for this event",

    // Actions
    deleteEvent: "Delete event",
    close: "Close",
    cancel: "Cancel",
    updateEvent: "Update event",
    createEvent: "Create event",
    accept: "Accept",
    decline: "Decline",
    maybe: "Maybe",
    going: "Going",

    // Export Modal
    chooseFormat: "Choose export format and date range",
    exportFormat: "Export format",
    pdfReport: "PDF Report",
    formattedReport: "Formatted print report",
    excelFile: "Excel file",
    spreadsheetData: "Spreadsheet with event data",
    calendarFile: "Calendar File",
    importCalendars: "Import to other calendars",
    dateRange: "Date range",
    thisWeekRange: "This week",
    thisMonthRange: "This month",
    lastMonth: "Last month",
    thisQuarter: "This quarter",
    thisYear: "This year",
    allEventsRange: "All events",
    exporting: "Exporting...",
    export: "Export",

    // Share Modal
    shareWith: "Share your calendar with others",
    shareVia: "Share via",
    facebook: "Facebook",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    whatsApp: "WhatsApp (link)",
    email: "Email",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    linkCopiedMessage: "Calendar link copied to clipboard",

    // Notifications
    eventUpdated: "Event Updated",
    eventCreated: "Event Created",
    hasBeenUpdated: "has been updated successfully",
    hasBeenCreated: "has been created successfully",
    rsvpUpdated: "RSVP Updated",
    responseUpdated: "Your response has been updated to",
    eventDeleted: "Event Deleted",
    hasBeenDeleted: "has been deleted",
    deleteConfirm: "Delete event",
    viewEvent: "View Event",
    more: "more",

    // Error Messages
    loading: "Loading...",
    noUserSession: "No user session found",
    noEventsFound: "No events found",
    unableToLoad: "Unable to load calendar events",
    failedToSave: "Failed to save event",
    failedToDelete: "Failed to delete event",
    missingInfo: "Missing required information for RSVP update",
    failedToUpdate: "Failed to update RSVP status",
    unknownUser: "Unknown User",

    // Months
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",

    // Days
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
  },

  ar: {
    // رأس التقويم
    calendar: "التقويم",
    advancedScheduling: "نظام جدولة متقدم مع إدارة ذكية للأحداث، تخطيط الإجازات، رؤى الإنتاجية، والتحليلات الشاملة",
    newEvent: "حدث جديد",
    new: "جديد",
    share: "مشاركة",

    // الإحصائيات
    totalEvents: "إجمالي الأحداث",
    thisMonth: "هذا الشهر",
    todayEvents: "أحداث اليوم",
    thisWeek: "هذا الأسبوع",
    upcoming: "القادمة",
    completed: "المكتملة",
    overdue: "المتأخرة",
    weeklyHours: "ساعات الأسبوع",
    meetings: "الاجتماعات",
    deadlines: "المواعيد النهائية",
    vacationDays: "أيام الإجازة",
    productivity: "الإنتاجية",
    fromLastMonth: "من الشهر الماضي",

    // قائمة المهام
    todoList: "قائمة المهام",
    addNewTask: "إضافة مهمة جديدة",
    typeTaskHere: "اكتب مهمتك هنا...",
    addTask: "إضافة المهمة",
    allTasks: "كل المهام",
    activeTasks: "قيد التنفيذ",
    completedTasks: "مكتملة",
    noTasks: "لا توجد مهام",
    noTasksDescription: "ابدأ بإضافة مهام لتنظيم وقتك",
    markComplete: "تحديد كمكتملة",
    deleteTask: "حذف المهمة",
    personalTasks: "شخصية",
    workTasks: "العمل",
    urgentTasks: "عاجلة",
    taskProgress: "نسبة الإنجاز",
    of: "من",
    tasksCompleted: "مهام مكتملة",
    category: "الفئة",
    taskDescription: "وصف المهمة",

    // أدوات التقويم
    calendarControls: "أدوات التقويم",
    searchEvents: "البحث عن الأحداث...",

    // أنواع الأحداث
    allEvents: "كل الأحداث",
    training: "التدريب",
    interviews: "المقابلات",
    reviews: "المراجعات",
    social: "الاجتماعية",
    deadline: "الموعد النهائي",
    vacation: "الإجازة",
    conferences: "المؤتمرات",
    eventCategories: "فئات الأحداث",

    // الأحداث القادمة
    upcomingEvents: "الأحداث القادمة",
    noUpcomingEvents: "لا توجد أحداث قادمة",
    calendarClear: "تقويمك خالٍ للأسبوع القادم",

    // الإجراءات السريعة
    quickActions: "إجراءات سريعة",
    shareCalendar: "مشاركة التقويم",
    exportCalendar: "تصدير التقويم",

    // نافذة الحدث
    createNewEvent: "إنشاء حدث جديد",
    editEvent: "تعديل الحدث",
    viewEventDetails: "عرض تفاصيل الحدث",
    eventOrganizedBy: "الحدث منظم من قبل",
    updateEventDetails: "تحديث تفاصيل وإعدادات الحدث",
    addNewEvent: "إضافة",
    toYourCalendar: "إلى تقويمك",
    organizedBy: "منظم من قبل",
    youAreAttendee: "أنت حاضر في هذا الحدث",
    yourCurrentRSVP: "ردك الحالي",
    noResponse: "لا يوجد رد",
    updateResponse: "استخدم الأزرار أدناه لتحديث ردك",

    // حقول نموذج الحدث
    eventTitle: "عنوان الحدث",
    enterEventTitle: "أدخل",
    title: "عنوان",
    description: "الوصف",
    addVacationNotes: "أضف ملاحظات الإجازة أو معلومات الاتصال أو تعليمات خاصة...",
    addProjectDetails: "أضف تفاصيل المشروع أو المتطلبات أو إرشادات التسليم...",
    addDetailedDescription: "أضف وصفاً مفصلاً أو جدول أعمال أو ملاحظات أو أهداف الاجتماع...",

    // التاريخ والوقت
    startDate: "تاريخ البداية",
    date: "التاريخ",
    endDate: "تاريخ النهاية",
    lastDayVacation: "آخر يوم من الإجازة",
    extendedDeadline: "موعد نهائي ممتد (اختياري)",
    multiDayEnd: "تاريخ انتهاء حدث متعدد الأيام",
    startTime: "وقت البداية",
    dueTime: "وقت الاستحقاق",
    duration: "المدة",
    minutes: "دقائق",
    minute: "دقيقة",
    hour: "ساعة",
    hours: "ساعات",
    allDay: "طوال اليوم",
    endDateEarlier: "لا يمكن أن يكون تاريخ النهاية قبل تاريخ البداية. يرجى اختيار تاريخ نهاية صالح.",

    // خصائص الحدث
    eventType: "نوع الحدث",
    priority: "الأولوية",
    lowPriority: "أولوية منخفضة",
    mediumPriority: "أولوية متوسطة",
    highPriority: "أولوية عالية",
    urgent: "عاجل",
    status: "الحالة",
    yourStatus: "حالتك",
    accepted: "مقبول",
    declined: "مرفوض",
    tentative: "مؤقت",
    scheduled: "مجدول",
    confirmed: "مؤكد",
    inProgress: "قيد التنفيذ",
    cancelled: "ملغى",
    postponed: "مؤجل",

    // الموقع
    venue: "المكان",
    meetingLocation: "موقع الاجتماع",
    location: "الموقع",
    conferenceVenue: "مركز المؤتمرات أو اسم المكان أو العنوان...",
    meetingRoom: "غرفة الاجتماع أو الرابط أو موقع المكتب...",
    locationDetails: "تفاصيل الموقع أو العنوان أو الرابط...",

    // الحضور
    eventAttendees: "حضور الحدث",
    attendees: "الحضور",
    organizer: "المنظم",
    typeNameEmail: "اكتب الاسم أو البريد الإلكتروني للبحث عن الموظفين، أو أدخل عناوين البريد مفصولة بفواصل",
    searchingFor: "البحث عن",
    found: "تم العثور",
    availableEmployees: "الموظفون المتاحون",
    loadingDirectory: "جارٍ تحميل دليل الموظفين...",
    noEmployeesFound: "لم يتم العثور على موظفين لـ",
    typeEmailManually: "يمكنك كتابة عناوين البريد الإلكتروني يدوياً",
    attendeesPlural: "حضور",
    attendee: "حاضر",
    willReceiveInvitations: "سيتلقون الدعوات",
    employeesAvailable: "موظف متاح في الدليل",

    // التكرار
    recurrence: "التكرار (اختياري)",
    noRecurrence: "لا يوجد تكرار",
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",
    yearly: "سنوي",

    // التذكيرات
    enableReminders: "تفعيل التذكيرات",
    reminders: "التذكيرات والإشعارات",
    emailRemindersEnabled: "تم تفعيل تذكيرات البريد الإلكتروني لهذا الحدث",

    // الإجراءات
    deleteEvent: "حذف الحدث",
    close: "إغلاق",
    cancel: "إلغاء",
    updateEvent: "تحديث الحدث",
    createEvent: "إنشاء الحدث",
    accept: "قبول",
    decline: "رفض",
    maybe: "ربما",
    going: "ذاهب",

    // نافذة التصدير
    chooseFormat: "اختر تنسيق التصدير والنطاق الزمني",
    exportFormat: "تنسيق التصدير",
    pdfReport: "تقرير PDF",
    formattedReport: "تقرير منسق للطباعة",
    excelFile: "ملف Excel",
    spreadsheetData: "جدول بيانات مع بيانات الأحداث",
    calendarFile: "ملف التقويم",
    importCalendars: "استيراد إلى تقويمات أخرى",
    dateRange: "النطاق الزمني",
    thisWeekRange: "هذا الأسبوع",
    thisMonthRange: "هذا الشهر",
    lastMonth: "الشهر الماضي",
    thisQuarter: "هذا الربع",
    thisYear: "هذا العام",
    allEventsRange: "كل الأحداث",
    exporting: "جارٍ التصدير...",
    export: "تصدير",

    // نافذة المشاركة
    shareWith: "شارك تقويمك مع الآخرين",
    shareVia: "مشاركة عبر",
    facebook: "فيسبوك",
    twitter: "تويتر",
    linkedin: "لينكدإن",
    whatsApp: "واتساب",
    email: "البريد الإلكتروني",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط",
    linkCopiedMessage: "تم نسخ رابط التقويم إلى الحافظة",

    // الإشعارات
    eventUpdated: "تم تحديث الحدث",
    eventCreated: "تم إنشاء الحدث",
    hasBeenUpdated: "تم تحديثه بنجاح",
    hasBeenCreated: "تم إنشاؤه بنجاح",
    rsvpUpdated: "تم تحديث الرد",
    responseUpdated: "تم تحديث ردك إلى",
    eventDeleted: "تم حذف الحدث",
    hasBeenDeleted: "تم حذفه",
    deleteConfirm: "حذف الحدث",
    viewEvent: "عرض الحدث",
    more: "المزيد",

    // رسائل الخطأ
    loading: "جارٍ التحميل...",
    noUserSession: "لم يتم العثور على جلسة مستخدم",
    noEventsFound: "لم يتم العثور على أحداث",
    unableToLoad: "تعذر تحميل أحداث التقويم",
    failedToSave: "فشل في حفظ الحدث",
    failedToDelete: "فشل في حذف الحدث",
    missingInfo: "معلومات مطلوبة مفقودة لتحديث الرد",
    failedToUpdate: "فشل في تحديث حالة الرد",
    unknownUser: "مستخدم غير معروف",

    // الأشهر
    january: "يناير",
    february: "فبراير",
    march: "مارس",
    april: "أبريل",
    may: "مايو",
    june: "يونيو",
    july: "يوليو",
    august: "أغسطس",
    september: "سبتمبر",
    october: "أكتوبر",
    november: "نوفمبر",
    december: "ديسمبر",

    // الأيام
    sun: "الأحد",
    mon: "الإثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
    sat: "السبت",
  }
};


// ===============================================
// UTILITY FUNCTIONS - وظائف مساعدة
// ===============================================

/**
 * تنسيق التاريخ إلى صيغة YYYY-MM-DD
 * @param {Date} date - التاريخ المطلوب تنسيقه
 * @returns {string} التاريخ المنسق
 */
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
// ⬅️ قبل const Calendar = ({ ... }) {}
// اكتب الكود ده قبل المكون الرئيسي

const TodoListComponent = ({
  todos,
  setTodos,
  newTodoText,
  setNewTodoText,
  todoFilter,
  setTodoFilter,
  todoCategory,
  setTodoCategory,
  theme,
  language,
  t,
  styles,
  screenSize
}) => {
  // إضافة مهمة
  const addTodo = (e) => {
    e.preventDefault();
    if (!newTodoText.trim()) return;
    const newTodo = {
      id: Date.now(),
      text: newTodoText.trim(),
      completed: false,
      category: todoCategory,
      createdAt: new Date().toISOString(),
    };
    setTodos([newTodo, ...todos]);
    setNewTodoText("");
  };

  // تبديل حالة المهمة
  const toggleTodo = (id) => {
    setTodos(todos.map(todo =>
      todo.id === id ? { ...todo, completed: !todo.completed } : todo
    ));
  };

  // حذف مهمة
  const deleteTodo = (id) => {
    setTodos(todos.filter(todo => todo.id !== id));
  };

  // فلترة المهام
  const getFilteredTodos = () => {
    if (todoFilter === "active") return todos.filter(t => !t.completed);
    if (todoFilter === "completed") return todos.filter(t => t.completed);
    return todos;
  };

  // إحصائيات المهام
  const getTodoStats = () => {
    const total = todos.length;
    const completed = todos.filter(t => t.completed).length;
    const progress = total > 0 ? Math.round((completed / total) * 100) : 0;
    return { total, completed, active: total - completed, progress };
  };

  const todoStats = getTodoStats();

  return (
    <>
      {/* الهيدر */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        paddingBottom: "16px",
        borderBottom: theme === "dark" ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.08)",
      }}>
        <h3 style={{
          fontSize: "24px",
          fontWeight: "700",
          color: theme === "dark" ? "#fff" : "#1a1a1a",
          margin: 0,
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}>
          <CheckCircle size={20} /> {t.todoList}
        </h3>
        <div style={{
          background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
          color: "#fff",
          padding: "6px 16px",
          borderRadius: "20px",
          fontSize: "14px",
          fontWeight: "700",
        }}>
          {todoStats.progress}%
        </div>
      </div>

      {/* فورم إضافة مهمة */}
      <form onSubmit={addTodo} style={{ marginBottom: "20px" }}>
        <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
          <input
            type="text"
            id="todo-input"
            value={newTodoText}
            onChange={(e) => {
              e.stopPropagation(); // ⬅️ ضيف ده
              setNewTodoText(e.target.value);
            }}
            dir={language === 'ar' ? 'rtl' : 'ltr'} // ⬅️ ضيف ده
            style={{
              ...(styles.formInput || {}),
              flex: 1,
              direction: language === 'ar' ? 'rtl' : 'ltr',
            }}
            placeholder={t.typeTaskHere}
            autoComplete="off"  // ⬅️ وده كمان
          />
          <select
            value={todoCategory}
            onChange={(e) => setTodoCategory(e.target.value)}
            style={{
              ...styles.formSelect,
              width: "120px",
            }}
          >
            <option value="personal">{t.personalTasks}</option>
            <option value="work">{t.workTasks}</option>
            <option value="urgent">{t.urgentTasks}</option>
          </select>
        </div>
        <button
          type="submit"
          style={styles.actionButton("primary", "medium")}
        >
          <Plus size={16} /> {t.addTask}
        </button>
      </form>

      {/* الفلاتر */}
      <div style={{
        display: "flex",
        gap: "8px",
        marginBottom: "20px",
        background: theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
        padding: "6px",
        borderRadius: "12px",
      }}>
        {["all", "active", "completed"].map((filter) => (
          <button
            key={filter}
            onClick={() => setTodoFilter(filter)}
            style={{
              ...styles.viewModeButton(todoFilter === filter),
              flex: 1,
            }}
          >
            {filter === "all" ? t.allTasks : filter === "active" ? t.activeTasks : t.completedTasks}
          </button>
        ))}
      </div>

      {/* قائمة المهام */}
      <div style={{
        maxHeight: "400px",
        overflowY: "auto",
        scrollbarWidth: "none",
      }}>
        {getFilteredTodos().length === 0 ? (
          <div style={styles.emptyState}>
            <CheckCircle style={styles.emptyIcon} />
            <h4 style={styles.emptyTitle}>{t.noTasks}</h4>
            <p style={styles.emptyDescription}>{t.noTasksDescription}</p>
          </div>
        ) : (
          getFilteredTodos().map((todo) => (
            <div
              key={todo.id}
              style={{
                padding: "16px",
                borderRadius: "12px",
                background: todo.completed
                  ? "rgba(16, 185, 129, 0.1)"
                  : theme === "dark" ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.7)",
                border: theme === "dark" ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.06)",
                marginBottom: "8px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                transition: "all 0.3s ease",
              }}
            >
              <input
                type="checkbox"
                checked={todo.completed}
                onChange={() => toggleTodo(todo.id)}
                style={{
                  width: "20px",
                  height: "20px",
                  accentColor: "#2e7cba",
                  cursor: "pointer",
                }}
              />
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: todo.completed ? "rgba(128,128,128,0.7)" : theme === "dark" ? "#fff" : "#1a1a1a",
                  textDecoration: todo.completed ? "line-through" : "none",
                }}>
                  {todo.text}
                </div>
                <div style={{
                  fontSize: "12px",
                  color: theme === "dark" ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)",
                  marginTop: "4px",
                }}>
                  {todo.category === "work" ? t.workTasks : todo.category === "urgent" ? t.urgentTasks : t.personalTasks}
                </div>
              </div>
              <button
                onClick={() => deleteTodo(todo.id)}
                style={{
                  background: "rgba(239, 68, 68, 0.1)",
                  border: "none",
                  color: "#ef4444",
                  padding: "8px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))
        )}
      </div>
    </>
  );
};
// Simple Todo List component (lightweight replacement)
const SimpleTodoList = ({
  todos,
  setTodos,
  newTodoText,
  setNewTodoText,
  todoFilter,
  setTodoFilter,
  todoCategory,
  setTodoCategory,
  theme,
  language,
  t,
  styles,
  screenSize,
  addTodo, // from Calendar - will perform backend POST
  deleteTodo, // from Calendar - will perform backend DELETE
  toggleTodo, // from Calendar - will perform backend toggle
}) => {
  const addLocalTodo = async (e) => {
    e.preventDefault();
    if (!newTodoText || !newTodoText.trim()) return;
    if (typeof addTodo === 'function') {
      await addTodo(e);
      return;
    }
    const nt = {
      id: Date.now(),
      text: newTodoText.trim(),
      completed: false,
      category: todoCategory || 'personal',
      createdAt: new Date().toISOString(),
    };
    setTodos([nt, ...todos]);
    setNewTodoText('');
  };

  const toggleLocal = async (id) => {
    if (typeof toggleTodo === 'function') {
      await toggleTodo(id);
      return;
    }
    setTodos(todos.map(t => t.id === id ? { ...t, completed: !t.completed } : t));
  };

  const deleteLocal = async (id) => {
    if (typeof deleteTodo === 'function') {
      await deleteTodo(id);
      return;
    }
    setTodos(todos.filter(t => t.id !== id));
  };

  const filtered = todoFilter === 'active' ? todos.filter(t => !t.completed) : todoFilter === 'completed' ? todos.filter(t => t.completed) : todos;

  const stats = {
    total: todos.length,
    completed: todos.filter(t => t.completed).length,
    progress: todos.length ? Math.round((todos.filter(t => t.completed).length / todos.length) * 100) : 0,
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: screenSize.isMobile ? 16 : 20,
    }}>
      {/* Header */}
      <div style={{
        padding: screenSize.isMobile ? '20px' : '24px',
        borderRadius: '18px',
        border: theme === 'dark' ? '2px solid rgba(16, 185, 129, 0.2)' : '2px solid rgba(16, 185, 129, 0.15)',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Decorative Element */}
        <div style={{
          position: 'absolute',
          top: '-30px',
          right: '-30px',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #2e7cba, #2e7cba)',
          opacity: 0.1,
          filter: 'blur(40px)',
        }} />

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1,
        }}>
          <div style={{ flex: 1 }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '8px',
            }}>
              <div style={{
                width: '44px',
                height: '44px',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #2e7cba, #2e7cba)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <CheckCircle size={22} color="#fff" strokeWidth={2.5} />
              </div>

              <h4 style={{
                margin: 0,
                fontSize: screenSize.isMobile ? 20 : 22,
                fontWeight: 800,
                color: theme === 'dark' ? '#fff' : '#1a1a1a',
                letterSpacing: '-0.5px',
              }}>
                {t.todoList}
              </h4>
            </div>

            {/* Progress Bar */}
            <div style={{
              width: '100%',
              height: '6px',
              borderRadius: '10px',
              overflow: 'hidden',
              marginTop: '12px',
            }}>
              <div style={{
                width: `${stats.progress}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #2e7cba, #2e7cba)',
                borderRadius: '10px',
                transition: 'width 0.5s ease',
              }} />
            </div>

            <p style={{
              fontSize: '12px',
              color: theme === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
              margin: '8px 0 0 0',
              fontWeight: 500,
            }}>
              <span style={{ fontWeight: 700, color: '#2e7cba' }}>{stats.completed}</span> {t.of || 'من'} {stats.total} {t.tasksCompleted || 'مكتملة'}
            </p>
          </div>

          {/* Circular Progress */}
          <div style={{ position: 'relative', width: '70px', height: '70px' }}>
            <svg width="70" height="70" style={{ transform: 'rotate(-90deg)' }}>
              <circle
                cx="35"
                cy="35"
                r="30"
                fill="none"
                stroke={theme === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}
                strokeWidth="6"
              />
              <circle
                cx="35"
                cy="35"
                r="30"
                fill="none"
                stroke="url(#gradient)"
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray={`${2 * Math.PI * 30}`}
                strokeDashoffset={`${2 * Math.PI * 30 * (1 - stats.progress / 100)}`}
                style={{ transition: 'stroke-dashoffset 0.6s ease' }}
              />
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#2e7cba" />
                  <stop offset="100%" stopColor="#2e7cba" />
                </linearGradient>
              </defs>
            </svg>
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '16px',
              fontWeight: 900,
              color: '#2e7cba',
            }}>
              {stats.progress}%
            </div>
          </div>
        </div>
      </div>

      {/* Add Form */}
      <form onSubmit={addLocalTodo} style={{
        display: 'flex',
        gap: screenSize.isMobile ? 8 : 10,
        flexDirection: screenSize.isMobile ? 'column' : 'row',
      }}>
        <input
          id="todo-input"
          value={newTodoText}
          onChange={(e) => setNewTodoText(e.target.value)}
          placeholder={t.typeTaskHere}
          dir={language === 'ar' ? 'rtl' : 'ltr'}
          style={{
            ...(styles.formInput || {}),
            flex: 1,
            padding: screenSize.isMobile ? '12px 16px' : '14px 18px',
            fontSize: '15px',
            fontWeight: 500,
            border: theme === 'dark' ? '2px solid rgba(16, 185, 129, 0.2)' : '2px solid rgba(16, 185, 129, 0.15)',
            borderRadius: '14px',
            background: theme === 'dark' ? 'rgba(255,255,255,0.05)' : '#fff',
            color: theme === 'dark' ? '#fff' : '#1a1a1a',
            outline: 'none',
            transition: 'all 0.3s ease',
            direction: language === 'ar' ? 'rtl' : 'ltr',
            unicodeBidi: 'plaintext',
            boxSizing: 'border-box',
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#2e7cba';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = theme === 'dark' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(16, 185, 129, 0.15)';
          }}
        />

        <div
          style={{
            width: screenSize.isMobile ? '100%' : 140,
            position: "relative"
          }}
        >
          <ReusableDropdown
            items={[
              { id: "personal", name: t.personalTasks },
              { id: "work", name: t.workTasks },
              { id: "urgent", name: t.urgentTasks }
            ]}
            value={todoCategory}
            onChange={(val) => setTodoCategory(val)}
            onSelect={(item) => {
              const value = typeof item === "string"
                ? item
                : item?.id || String(item);
              setTodoCategory(value);
            }}
            getItemKey={(it) =>
              typeof it === "string" ? it : it.id || String(it)
            }
            getItemLabel={(it) =>
              typeof it === "string" ? it : it.name || String(it)
            }
            placeholder={t.selectCategory || "اختر الفئة..."}
            theme={theme}
            language={language}
            maxItems={5}
          />
        </div>

        {/* زرار الإضافة */}
        <button
          type="submit"
          style={{
            width: screenSize.isMobile ? '100%' : 'auto',
            padding: screenSize.isMobile ? '12px 20px' : '14px 24px',
            background: 'linear-gradient(135deg, #2e7cba, #1e5a8a)',
            border: 'none',
            borderRadius: '14px',
            color: '#fff',
            fontSize: '15px',
            fontWeight: 700,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.background = 'linear-gradient(135deg, #1e5a8a, #2e7cba)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.background = 'linear-gradient(135deg, #2e7cba, #1e5a8a)';
          }}
        >
          <Plus size={18} strokeWidth={3} />
          <span>{language === 'ar' ? 'إضافة' : 'Add'}</span>
        </button>
      </form>

      {/* Filters */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: screenSize.isMobile ? 8 : 10,
      }}>
        {[
          { key: 'all', label: t.allTasks, count: stats.total },
          { key: 'active', label: t.activeTasks, count: stats.total - stats.completed },
          { key: 'completed', label: t.completedTasks, count: stats.completed }
        ].map(f => (
          <button
            key={f.key}
            onClick={() => setTodoFilter(f.key)}
            style={{
              padding: screenSize.isMobile ? '10px 8px' : '12px 10px',
              fontSize: screenSize.isMobile ? 12 : 13,
              fontWeight: 700,
              color: todoFilter === f.key ? '#fff' : theme === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
              background: todoFilter === f.key
                ? 'linear-gradient(135deg, #2e7cba, #2e7cba)'
                : theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
              border: todoFilter === f.key
                ? 'none'
                : theme === 'dark' ? '2px solid rgba(255,255,255,0.1)' : '2px solid rgba(0,0,0,0.08)',
              borderRadius: '12px',
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              transform: todoFilter === f.key ? 'translateY(-2px)' : 'translateY(0)',
            }}
            onMouseEnter={(e) => {
              if (todoFilter !== f.key) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.borderColor = '#2e7cba';
              }
            }}
            onMouseLeave={(e) => {
              if (todoFilter !== f.key) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)';
              }
            }}
          >
            <span style={{ fontSize: screenSize.isMobile ? 16 : 18 }}>{f.icon}</span>
            <span>{f.label}</span>
            <span style={{ fontSize: 10, opacity: 0.8 }}>{f.count}</span>
          </button>
        ))}
      </div>

      {/* Tasks List */}
      <div style={{
        maxHeight: screenSize.isMobile ? 300 : 360,
        overflowY: 'auto',
        paddingRight: '4px',
      }}>
        {filtered.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: screenSize.isMobile ? '40px 20px' : '50px 24px',
            background: theme === 'dark'
              ? 'linear-gradient(145deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))'
              : 'linear-gradient(145deg, #ffffff, #f8fafc)',
            borderRadius: '18px',
            border: theme === 'dark' ? '2px dashed rgba(255,255,255,0.1)' : '2px dashed rgba(0,0,0,0.1)',
          }}>
            <div style={{
              width: screenSize.isMobile ? 60 : 70,
              height: screenSize.isMobile ? 60 : 70,
              margin: '0 auto 20px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.15), rgba(5, 150, 105, 0.1))',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <CheckCircle size={screenSize.isMobile ? 30 : 36} color="#2e7cba" strokeWidth={2} />
            </div>
            <div style={{
              fontSize: screenSize.isMobile ? 16 : 18,
              fontWeight: 700,
              color: theme === 'dark' ? '#fff' : '#1a1a1a',
              marginBottom: '8px',
            }}>
              {t.noTasks}
            </div>
            <div style={{
              fontSize: screenSize.isMobile ? 13 : 14,
              color: theme === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
            }}>
              {t.noTasksDescription}
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {filtered.map((todo, index) => (
              <div
                key={todo.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: screenSize.isMobile ? 12 : 14,
                  borderRadius: 14,
                  background: todo.completed
                    ? theme === 'dark'
                      ? 'linear-gradient(135deg, rgba(16, 185, 129, 0.08), rgba(5, 150, 105, 0.05))'
                      : 'linear-gradient(135deg, rgba(16, 185, 129, 0.06), rgba(5, 150, 105, 0.03))'
                    : theme === 'dark'
                      ? 'linear-gradient(145deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))'
                      : 'linear-gradient(145deg, #ffffff, #f8fafc)',
                  border: theme === 'dark'
                    ? `2px solid ${todo.completed ? 'rgba(16, 185, 129, 0.25)' : 'rgba(255,255,255,0.08)'}`
                    : `2px solid ${todo.completed ? 'rgba(16, 185, 129, 0.2)' : 'rgba(0,0,0,0.06)'}`,
                  marginBottom: screenSize.isMobile ? 6 : 8,
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  animation: `slideIn 0.3s ease ${index * 0.05}s both`,
                  position: 'relative',
                  overflow: 'hidden',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                {/* Left Bar */}
                <div style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: '4px',
                  background: todo.completed
                    ? 'linear-gradient(180deg, #2e7cba, #2e7cba)'
                    : 'transparent',
                  borderRadius: '0 4px 4px 0',
                }} />

                {/* Checkbox */}
                <div
                  onClick={() => toggleLocal(todo.id)}
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '8px',
                    border: `2.5px solid ${todo.completed ? '#2e7cba' : theme === 'dark' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.25)'}`,
                    background: todo.completed ? 'linear-gradient(135deg, #2e7cba, #2e7cba)' : 'transparent',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    flexShrink: 0,
                  }}
                >
                  {todo.completed && (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path
                        d="M11 4L5.5 9.5L3 7"
                        stroke="#fff"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>

                {/* Text */}
                <div style={{
                  flex: 1,
                  fontSize: screenSize.isMobile ? 14 : 15,
                  fontWeight: 600,
                  color: todo.completed
                    ? theme === 'dark' ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.35)'
                    : theme === 'dark' ? '#fff' : '#1a1a1a',
                  textDecoration: todo.completed ? 'line-through' : 'none',
                  wordBreak: 'break-word',
                }}>
                  {todo.text}
                </div>

                {/* Delete Button */}
                <button
                  onClick={() => deleteLocal(todo.id)}
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '10px',
                    background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08))',
                    border: '1px solid rgba(239, 68, 68, 0.2)',
                    color: '#ef4444',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    flexShrink: 0,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, rgba(239, 68, 68, 0.25), rgba(220, 38, 38, 0.15))';
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08))';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <Trash2 size={screenSize.isMobile ? 14 : 16} strokeWidth={2} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Animation CSS */}
      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};



// ===============================================
// MAIN CALENDAR COMPONENT - المكون الرئيسي للتقويم
// ===============================================
const Calendar = ({
  currentInfinityCode: _currentInfinityCodeProp = null,
}) => {
  const { theme } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext);
  // Merge English defaults with selected language so missing keys fallback to English
  const t = { ...translations.en, ...(translations[language] || {}) };

  // Profile from /users/me; derive currentInfinityCode with profile > prop > localStorage priority
  const { profile } = useProfile();
  const currentInfinityCode = _currentInfinityCodeProp ?? profile?.infinityCode ?? localStorage.getItem("infinityCode");

  // Log data source for each identity field
  useEffect(() => {
    console.group("[Calendar] Data source report");
    console.log("infinityCode :", profile?.infinityCode  ? `✅ /users/me (${profile.infinityCode})`  : `⚠️ localStorage (${localStorage.getItem("infinityCode")})`);
    console.log("employeeName :", profile?.employeeName  ? `✅ /users/me (${profile.employeeName})`  : `⚠️ localStorage (${localStorage.getItem("userName")})`);
    console.log("employeeEmail:", profile?.employeeEmail ? `✅ /users/me (${profile.employeeEmail})` : `⚠️ localStorage (${localStorage.getItem("userEmail")})`);
    console.groupEnd();
  }, [profile]);
  const [newTodoText, setNewTodoText] = useState("");
  // في أول الكومبوننت مع باقي الـ states
  const [showAddModal, setShowAddModal] = useState(false);

  // Ensure document direction matches current language (defensive):
  useEffect(() => {
    try {
      const dir = language === "ar" ? "rtl" : "ltr";
      // ⬅️ بس لو الـ dir فعلاً اتغير
      if (document.dir !== dir) {
        document.dir = dir;
      }
      if (document.documentElement && document.documentElement.dir !== dir) {
        document.documentElement.dir = dir;
        document.documentElement.lang = language || "en";
      }
    } catch (e) {
      // noop in non-browser environments
    }
  }, [language]);

  // ===============================================
  // STATE MANAGEMENT - إدارة الحالة
  // ===============================================

  // حالات التاريخ والعرض
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDates, setSelectedDates] = useState(new Set());
  const [vacationDates, setVacationDates] = useState(new Set());
  const [viewMode, setViewMode] = useState("month");

  // حالات النوافذ المنبثقة
  const [showEventModal, setShowEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showVacationModal, setShowVacationModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  // Helpers to export calendar as image or PDF
  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const s = document.createElement("script");
      s.src = src;
      s.onload = () => resolve();
      s.onerror = (e) => reject(e);
      document.head.appendChild(s);
    });

  // Create a canvas of the calendar element (reused by export and share)
  const createCalendarCanvas = async () => {
    const el = document.getElementById("calendar-export");
    if (!el) throw new Error("Calendar element not found");
    if (typeof window.html2canvas === "undefined") {
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"
      );
    }

    const clone = el.cloneNode(true);
    clone.style.display = "block";
    clone.style.position = "absolute";
    clone.style.left = "-9999px";
    clone.style.width = `${el.offsetWidth || 900}px`;

    const minimalTextColor = document.createElement("style");
    minimalTextColor.innerHTML = `
      #calendar-export, #calendar-export * {
        color: #111 !important;
        -webkit-text-fill-color: #111 !important;
      }
    `;
    clone.insertBefore(minimalTextColor, clone.firstChild);
    document.body.appendChild(clone);

    const scale = Math.max(2, window.devicePixelRatio || 2);
    const canvas = await window.html2canvas(clone, {
      scale,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    // leave clone in DOM for html2canvas to render, then remove it
    clone.remove();
    return canvas;
  };

  const exportCalendar = async (asPdf = false) => {
    try {
      const canvas = await createCalendarCanvas();
      if (!asPdf) {
        const imgData = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = imgData;
        const fileName = `Calendar-${monthNames[currentDate.getMonth()]}-${currentDate.getFullYear()}.png`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return;
      }

      if (typeof window.jspdf === "undefined") {
        await loadScript(
          "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"
        );
      }

      let jsPDFConstructor = null;
      if (window.jspdf && window.jspdf.jsPDF) jsPDFConstructor = window.jspdf.jsPDF;
      else if (window.jsPDF) jsPDFConstructor = window.jsPDF;
      else if (window.jspdf) jsPDFConstructor = window.jspdf;
      if (!jsPDFConstructor) throw new Error("jsPDF not available");

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDFConstructor("p", "pt", "a4");
      const pageWidth = 595.28;
      const pageHeight = 841.89;
      const margin = 20;

      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let remainingHeight = imgHeight;
      while (remainingHeight > 0) {
        pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
        remainingHeight -= pageHeight - margin * 2;
        if (remainingHeight > 0) pdf.addPage();
      }

      const fileName = `Calendar-${monthNames[currentDate.getMonth()]}-${currentDate.getFullYear()}.pdf`;
      pdf.save(fileName);
    } catch (err) {
      console.error("Export failed", err);
      sendNotification({
        title: language === "ar" ? "خطأ" : "Error",
        message:
          language === "ar"
            ? "فشل في إنشاء الصيغة المطلوبة. حاول مرة أخرى أو استخدام ميزة الطباعة."
            : "Failed to generate export. Try again or use Print to save as PDF.",
        type: "error",
      });
    }
  };
  // حالات To-Do List
  // ⬅️ تحميل المهام من localStorage عند بدء التشغيل
  // const [todos, setTodos] = useState(() => {
  //   try {
  //     const savedTodos = localStorage.getItem('calendarTodos');
  //     return savedTodos ? JSON.parse(savedTodos) : [];
  //   } catch (error) {
  //     console.error('Error loading todos:', error);
  //     return [];
  //   }
  // }); 
  const [todoFilter, setTodoFilter] = useState("all");
  const [todoCategory, setTodoCategory] = useState("personal");
  const [showNotificationSettings, setShowNotificationSettings] =
    useState(false);

  // حالات التصفية والبحث
  const [filterType, setFilterType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionFilter, setSuggestionFilter] = useState("");

  // حالات التحميل والأخطاء
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // حالات الرسوم المتحركة والتفاعل
  const [animatedStats, setAnimatedStats] = useState(false);
  const [hoveredDate, setHoveredDate] = useState(null);
  const [dragMode, setDragMode] = useState(false);
  const [dragStart, setDragStart] = useState(null);

  // حالات تحديد النطاق الزمني
  const [dateRangeMode, setDateRangeMode] = useState(false);
  const [dateRangeStart, setDateRangeStart] = useState(null);
  const [dateRangeEnd, setDateRangeEnd] = useState(null);
  const [rangeType, setRangeType] = useState("events");

  // حالات التصدير والمشاركة
  const [exportFormat, setExportFormat] = useState("pdf");
  const [exportDateRange, setExportDateRange] = useState("this_month");

  // حالات الإشعارات
  const [notifications, setNotifications] = useState([]);
  const [notificationSettings, setNotificationSettings] = useState({
    emailReminders: true,
    pushNotifications: true,
    weeklyDigest: true,
    eventUpdates: true,
    vacationAlerts: true,
  });

  // حالات الموظفين والأسماء
  const [originatorNames, setOriginatorNames] = useState({});
  const [employeeList, setEmployeeList] = useState([]);

  // بيانات الأحداث والإحصائيات
  const [events, setEvents] = useState([]);
  const [calendarStats, setCalendarStats] = useState({
    totalEvents: 0,
    thisMonth: 0,
    upcoming: 0,
    completed: 0,
    meetings: 0,
    deadlines: 0,
    vacationDays: 0,
    productivity: 85,
    weeklyHours: 42.5,
    overdueEvents: 3,
    todayEvents: 5,
    thisWeekEvents: 12,
  });
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  // ===============================================
  // API CONFIGURATION - إعدادات API
  // ===============================================
  const API_BASE = `${BASE_URL}/calendar`;

  // ===============================================
  // EVENT TYPES - أنواع الأحداث
  // ===============================================
  const eventTypes = [
    // {
    //   id: "event",
    //   icon: Plus,
    //   color: "#3b82f6",
    // },
    // {
    //   id: "all",
    //   name: t.allEvents,
    //   icon: CalendarIcon,
    //   color: "#2e7cba",
    //   description: language === "ar" ? "عرض جميع الأحداث المجدولة" : "View all scheduled events",
    //   category: "general",
    // },
    {
      id: "meeting",
      name: t.meetings,
      icon: Users,
      color: "#2e7cba",
      description: language === "ar" ? "اجتماعات الفريق والمؤتمرات" : "Team meetings and conferences",
      category: "work",
    },
    {
      id: "training",
      name: t.training,
      icon: GraduationCap,
      color: "#2e7cba",
      description: language === "ar" ? "جلسات التعلم والتطوير" : "Learning and development sessions",
      category: "development",
    },
    {
      id: "interview",
      name: t.interviews,
      icon: UserCheck,
      color: "#8b5cf6",
      description: language === "ar" ? "مقابلات وتقييمات المرشحين" : "Candidate interviews and assessments",
      category: "hr",
    },
    {
      id: "review",
      name: t.reviews,
      icon: Briefcase,
      color: "#f59e0b",
      description: language === "ar" ? "مراجعات وتقييمات الأداء" : "Performance reviews and evaluations",
      category: "hr",
    },
    {
      id: "social",
      name: t.social,
      icon: Coffee,
      color: "#ef4444",
      description: language === "ar" ? "بناء الفريق والأحداث الاجتماعية" : "Team building and social events",
      category: "social",
    },
    {
      id: "deadline",
      name: t.deadlines,
      icon: AlertCircle,
      color: "#dc2626",
      description: language === "ar" ? "المواعيد النهائية للمشروع والمعالم" : "Project deadlines and milestones",
      category: "work",
    },
    {
      id: "vacation",
      name: t.vacation,
      icon: Sun,
      color: "#06b6d4",
      description: language === "ar" ? "الوقت الشخصي والعطلات" : "Personal time off and holidays",
      category: "personal",
    },
    {
      id: "conference",
      name: t.conferences,
      icon: Globe,
      color: "#84cc16",
      description: language === "ar" ? "مؤتمرات وأحداث الصناعة" : "Industry conferences and events",
      category: "professional",
    },
  ];

  // ===============================================
  // RESPONSIVE BREAKPOINTS - نقاط الاستجابة
  // ===============================================
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth <= 768,
    isTablet: window.innerWidth > 768 && window.innerWidth <= 1024,
    isDesktop: window.innerWidth > 1024,
  });

  // مراقبة تغيير حجم الشاشة
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setScreenSize({
        width,
        height,
        isMobile: width <= 768,
        isTablet: width > 768 && width <= 1024,
        isDesktop: width > 1024,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // ⬅️ حفظ المهام في localStorage كل ما تتغير
  // useEffect(() => {
  //   try {
  //     localStorage.setItem('calendarTodos', JSON.stringify(todos));
  //   } catch (error) {
  //     console.error('Error saving todos:', error);
  //   }
  // }, [todos]);
  // ✅ ضيف دول
  const [todos, setTodos] = useState([]);

  // Fetch todos from backend
  useEffect(() => {
    const fetchTodos = async () => {
      if (!currentInfinityCode) return;

      try {
        const response = await apiFetch(`${BASE_URL}/todos/${currentInfinityCode}`, {
          method: "GET",
        });
        const data = await response.json();
        setTodos(data.todos || []);
      } catch (error) {
        console.error("Error fetching todos:", error);
      }
    };

    fetchTodos();
  }, [currentInfinityCode]);

  // ===============================================
  // RESPONSIVE STYLES - الأنماط المتجاوبة
  // ===============================================
  const getResponsiveStyles = () => {
    const { isMobile, isTablet, isDesktop } = screenSize;
    const isRTL = language === "ar";

    return {
      // الحاوية الرئيسية - متجاوبة حسب حجم الشاشة
      container: {
        padding: isMobile ? "12px" : isTablet ? "16px" : "24px",
        maxWidth: "100%",
        margin: "0 auto",
        minHeight: "100vh",
        background:
          theme === "dark"
            ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)"
            : "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)",
        position: "relative",
        boxSizing: "border-box",
        direction: isRTL ? "rtl" : "ltr",
      },

      // قسم الرأس - متجاوب
      headerSection: {
        padding: isMobile ? "20px 16px" : isTablet ? "30px 24px" : "40px 32px",
        borderRadius: isMobile ? "16px" : "24px",
        marginBottom: isMobile ? "16px" : isTablet ? "24px" : "32px",
        marginTop: -40,
        backdropFilter: "blur(25px) saturate(180%)",
        WebkitBackdropFilter: "blur(25px) saturate(180%)",
        background:
          theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        boxShadow:
          theme === "dark"
            ? "0 20px 40px rgba(0,0,0,0.4)"
            : "0 20px 40px rgba(0,0,0,0.12)",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.3s ease",
      },

      // محتوى الرأس
      headerContent: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "flex-start" : "center",
        gap: isMobile ? "20px" : "32px",
        position: "relative",
        zIndex: 1,
      },

      // الجانب الأيسر من الرأس
      headerLeft: {
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "16px" : "32px",
        flex: 1,
      },

      // عنوان الرأس
      headerTitle: {
        fontSize: isMobile ? "28px" : isTablet ? "36px" : "42px",
        fontWeight: "900",
        margin: "0 0 0px 0",
        color: theme === "dark" ? "#ffffff" : "#1a1a1a",
        letterSpacing: "-0.02em",
        lineHeight: "1.1",
        textShadow:
          theme === "dark"
            ? "0 2px 4px rgba(0,0,0,0.3)"
            : "0 2px 4px rgba(0,0,0,0.1)",
        textAlign: isRTL ? "right" : "left",
        marginBottom: 20,

      },

      // حاوية نص الرأس
      headerText: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        gap: isMobile ? "12px" : "18px",
        width: "100%",
      },

      // العنوان الفرعي
      headerSubtitle: {
        fontSize: isMobile ? "14px" : isTablet ? "16px" : "18px",
        color:
          theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
        margin: 0,
        lineHeight: "1.6",
        maxWidth: isMobile ? "100%" : "500px",
        textAlign: isRTL ? "right" : "left",
      },

      // أزرار الرأس
      headerActions: {
        display: "flex",
        gap: isMobile ? "8px" : "16px",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: isMobile ? "center" : "flex-end",
        width: isMobile ? "100%" : "auto",
        flexDirection: isRTL ? "row" : "row-reverse",
      },

      // زر التفصيل
      detailButton: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 16px",
        borderRadius: "8px",
        border: "none",
        background: "transparent",
      },

      // شبكة الإحصائيات - متجاوبة
      statsGrid: {
        display: "grid",
        gridTemplateColumns: isMobile
          ? "repeat(2, 1fr)"
          : isTablet
            ? "repeat(3, 1fr)"
            : "repeat(auto-fit, minmax(200px, 1fr))",
        gap: isMobile ? "12px" : isTablet ? "16px" : "24px",
        marginBottom: isMobile ? "20px" : isTablet ? "30px" : "40px",
      },

      // بطاقة الإحصائيات
      statCard: (color, index) => ({
        background:
          theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: isMobile ? "16px 12px" : isTablet ? "24px 20px" : "32px 28px",
        borderRadius: isMobile ? "12px" : "20px",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        backdropFilter: "blur(25px) saturate(180%)",
        WebkitBackdropFilter: "blur(25px) saturate(180%)",
        boxShadow:
          theme === "dark"
            ? "0 20px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 20px 40px rgba(0,0,0,0.12)",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        transform: animatedStats ? "translateY(0)" : "translateY(30px)",
        opacity: animatedStats ? 1 : 0,
        transitionDelay: `${index * 100}ms`,
      }),

      // قيمة الإحصائية
      statValue: {
        fontSize: isMobile ? "24px" : isTablet ? "30px" : "36px",
        fontWeight: "900",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        lineHeight: "1",
        margin: "0 0 8px 0",
        letterSpacing: "-0.02em",
        textAlign: isRTL ? "right" : "left",
      },

      // تسمية الإحصائية
      statLabel: {
        fontSize: isMobile ? "11px" : "14px",
        fontWeight: "600",
        color:
          theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        marginBottom: "12px",
        textAlign: isRTL ? "right" : "left",
      },

      // لوحة التحكم
      controlPanel: {
        background:
          theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: isMobile ? "16px" : isTablet ? "24px" : "32px",
        borderRadius: isMobile ? "16px" : "24px",
        marginBottom: isMobile ? "16px" : isTablet ? "24px" : "32px",
        backdropFilter: "blur(25px) saturate(180%)",
        WebkitBackdropFilter: "blur(25px) saturate(180%)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        boxShadow:
          theme === "dark"
            ? "0 20px 40px rgba(0,0,0,0.4)"
            : "0 20px 40px rgba(0,0,0,0.12)",
        transition: "all 0.3s ease",
      },

      // صف التحكم
      controlRow: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "12px" : "20px",
        alignItems: isMobile ? "stretch" : "center",
        flexWrap: "wrap",
        marginBottom: isMobile ? "16px" : "24px",
      },

      // حاوية البحث
      searchContainer: {
        position: "relative",
        flex: isMobile ? "none" : 1,
        minWidth: isMobile ? "100%" : "320px",
        width: isMobile ? "100%" : "auto",
      },

      // حقل البحث
      searchInput: {
        width: "100%",
        padding: isMobile ? "12px 16px 12px 48px" : "16px 20px 16px 56px",
        paddingLeft: isRTL ? "16px" : isMobile ? "48px" : "56px",
        paddingRight: isRTL ? isMobile ? "48px" : "56px" : "16px",
        borderRadius: isMobile ? "12px" : "16px",
        border:
          theme === "dark"
            ? "2px solid rgba(255,255,255,0.12)"
            : "2px solid rgba(0,0,0,0.08)",
        background:
          theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        fontSize: isMobile ? "14px" : "15px",
        fontWeight: "500",
        outline: "none",
        transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        backdropFilter: "blur(10px)",
        boxSizing: "border-box",
        textAlign: isRTL ? "right" : "left",
      },

      // حاوية التقويم الرئيسية - متجاوبة
      calendarContainer: {
        display: "grid",
        gridTemplateColumns: "1fr 95px",
        gap: isMobile ? "16px" : isTablet ? "24px" : "32px",
        alignItems: "start",
        marginBottom: isMobile ? "40px" : isTablet ? "48px" : "64px",
      },

      // التقويم الرئيسي
      calendarMain: {

        background:
          theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: isMobile ? "16px" : isTablet ? "24px" : "32px",
        borderRadius: isMobile ? "16px" : "24px",
        backdropFilter: "blur(25px) saturate(180%)",
        WebkitBackdropFilter: "blur(25px) saturate(180%)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        boxShadow:
          theme === "dark"
            ? "0 20px 40px rgba(0,0,0,0.4)"
            : "0 20px 40px rgba(0,0,0,0.12)",
        transition: "all 0.3s ease",
        width: "100%",
        //
        gap: "16px",
        overflow: "hidden",
      },

      // رأس التقويم
      calendarHeader: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "center" : "center",
        gap: isMobile ? "16px" : "20px",
        marginBottom: isMobile ? "20px" : isTablet ? "24px" : "32px",
        paddingBottom: isMobile ? "16px" : isTablet ? "20px" : "24px",
        borderBottom:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(0,0,0,0.08)",
      },

      // التنقل في التقويم
      calendarNavigation: {
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "12px" : "20px",
        order: isMobile ? 1 : 0,
        flexDirection: isRTL ? "row-reverse" : "row",
      },

      // زر التنقل
      navButton: {
        width: isMobile ? "40px" : "48px",
        height: isMobile ? "40px" : "48px",
        borderRadius: isMobile ? "10px" : "14px",
        border: "none",
        background:
          theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        backdropFilter: "blur(10px)",
        fontWeight: "600",
      },

      // الشهر الحالي
      currentMonth: {
        fontSize: isMobile ? "18px" : isTablet ? "20px" : "24px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        minWidth: isMobile ? "200px" : "280px",
        textAlign: "center",
        letterSpacing: "-0.01em",
      },

      // أزرار وضع العرض
      viewModeButtons: {
        display: "flex",
        gap: isMobile ? "4px" : "8px",
        background:
          theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)",
        borderRadius: isMobile ? "12px" : "16px",
        padding: isMobile ? "4px" : "6px",
        backdropFilter: "blur(10px)",
        order: isMobile ? 2 : 0,
      },

      // زر وضع العرض
      viewModeButton: (isActive) => ({
        padding: isMobile ? "8px 12px" : "12px 20px",
        borderRadius: isMobile ? "8px" : "12px",
        border: "none",
        background: isActive
          ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
          : "transparent",
        color: isActive
          ? "#fff"
          : theme === "dark"
            ? "rgba(255,255,255,0.7)"
            : "rgba(26,26,26,0.7)",
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        textTransform: "uppercase",
        letterSpacing: "0.3px",
      }),

      // شبكة التقويم
      calendarGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gap: "10px",
        background:
          theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
        borderRadius: isMobile ? "8px" : "12px",
        overflow: "hidden",
        width: "100%",
      },

      // رأس يوم التقويم
      calendarDayHeader: {
        background:
          theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: isMobile ? "8px 4px" : "16px 8px",
        textAlign: "center",
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "600",
        color:
          theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
      },

      // يوم التقويم
      calendarDay: (dayObj, isSelected, isToday, isVacation, isInRange) => {
        const { date, isCurrentMonth } = dayObj;
        const hasEvents = getEventsForDate(date).length > 0;

        return {
          background: hasEvents
            ? "linear-gradient(135deg, #ef4444 60%, #dc2626 100%)"
            : isVacation
              ? "linear-gradient(135deg, #06b6d4 60%, #0891b2 100%)"
              : isSelected
                ? "linear-gradient(135deg, #2e7cba 60%, #2e7cba 100%)"
                : isToday
                  ? "linear-gradient(135deg, #2e7cba 60%, #2e7cba 100%)"
                  : isInRange
                    ? "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(99, 102, 241, 0.15))"
                    : theme === "dark"
                      ? "rgba(255,255,255,0.03)"
                      : "rgba(255,255,255,0.85)",
          minHeight: isMobile ? "80px" : isTablet ? "100px" : "120px",
          padding: isMobile ? "8px 6px 6px 6px" : "14px 10px 10px 10px",
          position: "relative",
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          opacity: isCurrentMonth ? 1 : 0.35,
          backdropFilter: "blur(12px)",
          border: hasEvents
            ? "2px solid rgba(220,38,38,0.95)"
            : dateRangeMode
              ? "2px dashed rgba(59, 130, 246, 0.5)"
              : "1px solid rgba(255,255,255,0.12)",
          borderRadius: isMobile ? "10px" : "18px",
          overflow: "hidden",
          boxShadow:
            hasEvents
              ? "0 6px 22px 0 rgba(220,38,38,0.12)"
              : isSelected || isToday || isVacation
                ? "0 4px 18px 0 rgba(59,130,246,0.10)"
                : "0 1px 4px 0 rgba(0,0,0,0.04)",
          zIndex: isToday ? 2 : 1,
          outline: isToday ? "2px solid #2e7cba" : undefined,
        };
      },

      // رقم يوم التقويم
      calendarDayNumber: (isSelected, isToday, isVacation, hasEvents) => ({
        fontSize: isMobile ? "14px" : "18px",
        fontWeight: "800",
        color:
          isSelected || isToday || isVacation || hasEvents
            ? "#fff"
            : theme === "dark"
              ? "#fff"
              : "#1a1a1a",
        marginBottom: isMobile ? "4px" : "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: isRTL ? "flex-start" : "flex-end",
        letterSpacing: "-0.02em",
        textShadow:
          isSelected || isToday || isVacation || hasEvents
            ? "0 2px 8px rgba(0,0,0,0.18)"
            : "none",
        background:
          isSelected || isToday || isVacation || hasEvents
            ? "rgba(0,0,0,0.08)"
            : "transparent",
        borderRadius: isMobile ? "6px" : "8px",
        padding: "0 6px",
        minHeight: isMobile ? "20px" : "28px",
        minWidth: isMobile ? "20px" : "28px",
        width: "fit-content",
        marginLeft: isRTL ? "0" : "auto",
        marginRight: isRTL ? "auto" : "0",
      }),

      // عنصر الحدث
      eventItem: (event) => ({
        background: `linear-gradient(90deg, ${event.color}CC 60%, ${event.color}99 100%)`,
        color: "#fff",
        padding: isMobile ? "3px 6px" : "5px 10px",
        borderRadius: isMobile ? "6px" : "8px",
        fontSize: isMobile ? "10px" : "12px",
        fontWeight: "700",
        marginBottom: isMobile ? "3px" : "5px",
        cursor: "pointer",
        transition: "all 0.18s cubic-bezier(0.25,0.46,0.45,0.94)",
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "4px" : "6px",
        backdropFilter: "blur(8px)",
        border: `1.5px solid ${event.color}`,
        boxShadow: `0 2px 8px 0 ${event.color}22`,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        textAlign: isRTL ? "right" : "left",
        flexDirection: isRTL ? "row-reverse" : "row",
      }),

      sidebar: {
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? "16px" : "24px",
        order: isMobile ? -1 : 0,
      },

      // بطاقة الشريط الجانبي
      sidebarCard: {
        background:
          theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: isMobile ? "20px 16px" : "28px",
        borderRadius: isMobile ? "16px" : "20px",
        backdropFilter: "blur(25px) saturate(180%)",
        WebkitBackdropFilter: "blur(25px) saturate(180%)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        marginBottom: 33,
        boxShadow:
          theme === "dark"
            ? "0 20px 40px rgba(0,0,0,0.4)"
            : "0 20px 40px rgba(0,0,0,0.12)",
        transition: "all 0.3s ease",
      },
      sidebarCard1: {
        background:
          theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: isMobile ? "20px 16px" : "28px",
        borderRadius: isMobile ? "16px" : "20px",
        backdropFilter: "blur(25px) saturate(180%)",
        WebkitBackdropFilter: "blur(25px) saturate(180%)",
        maxWidth: "100px",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        marginBottom: 33,
        boxShadow:
          theme === "dark"
            ? "0 20px 40px rgba(0,0,0,0.4)"
            : "0 20px 40px rgba(0,0,0,0.12)",
        transition: "all 0.3s ease",
      },

      // عنوان الشريط الجانبي
      sidebarTitle: {
        fontSize: isMobile ? "16px" : "20px",
        fontWeight: "700",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        marginBottom: isMobile ? "16px" : "20px",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexDirection: isRTL ? "row" : "row-reverse",
        textAlign: isRTL ? "right" : "left",
      },

      // زر الإجراء
      actionButton: (variant = "default", size = "medium") => {
        const variants = {
          default: {
            background:
              theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)",
            color: theme === "dark" ? "#fff" : "#1a1a1a",
            border:
              theme === "dark"
                ? "2px solid rgba(255,255,255,0.15)"
                : "2px solid rgba(0,0,0,0.08)",
          },
          primary: {
            background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
            color: "#fff",
            border: "none",
            // boxShadow: "0 8px 25px rgba(59, 130, 246, 0.4)",
          },
          success: {
            background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
            color: "#fff",
            border: "none",
            // boxShadow: "0 8px 25px rgba(16, 185, 129, 0.4)",
          },
          warning: {
            background: "linear-gradient(135deg, #f59e0b, #d97706)",
            color: "#fff",
            border: "none",
            boxShadow: "0 8px 25px rgba(245, 158, 11, 0.4)",
          },
          danger: {
            background: "linear-gradient(135deg, #ef4444, #dc2626)",
            color: "#fff",
            border: "none",
            boxShadow: "0 8px 25px rgba(239, 68, 68, 0.4)",
          },
        };

        const sizes = {
          small: {
            padding: isMobile ? "8px 12px" : "10px 16px",
            fontSize: isMobile ? "12px" : "13px",
          },
          medium: {
            padding: isMobile ? "10px 16px" : "14px 24px",
            fontSize: isMobile ? "13px" : "14px",
          },
          large: {
            padding: isMobile ? "14px 20px" : "18px 32px",
            fontSize: isMobile ? "14px" : "16px",
          },
        };

        return {
          ...variants[variant],
          ...sizes[size],
          borderRadius: isMobile ? "10px" : "14px",
          fontWeight: "700",
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: isMobile ? "8px" : "10px",
          outline: "none",
          letterSpacing: "0.3px",
          textTransform: "uppercase",
          backdropFilter: "blur(15px)",
          position: "relative",
          overflow: "hidden",
          whiteSpace: "nowrap",
          flexDirection: isRTL ? "row-reverse" : "row",
        };
      },

      // النافذة المنبثقة - متجاوبة
      modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(12px)",
        padding: isMobile ? "10px" : "20px",
      },

      // حاوية النافذة المنبثقة
      modalContainer: {
        background:
          theme === "dark"
            ? "rgba(15, 23, 42, 0.95)"
            : "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(30px) saturate(180%)",
        WebkitBackdropFilter: "blur(30px) saturate(180%)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.12)"
            : "1px solid rgba(0,0,0,0.08)",
        borderRadius: isMobile ? "16px" : "24px",
        padding: "0",
        width: "100%",
        maxWidth: isMobile ? "95vw" : "700px",
        maxHeight: isMobile ? "95vh" : "90vh",
        overflow: "hidden",
        boxShadow: "0 32px 64px -12px rgba(0,0,0,0.6)",
        direction: isRTL ? "rtl" : "ltr",
      },

      // رأس النافذة المنبثقة
      modalHeader: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "flex-start" : "center",
        gap: isMobile ? "16px" : "20px",
        padding: isMobile ? "20px 20px 0 20px" : "32px 32px 0 32px",
        marginBottom: isMobile ? "16px" : "24px",
      },

      // قسم عنوان النافذة المنبثقة
      modalTitleSection: {
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "16px" : "20px",
        flex: 1,
        flexDirection: isRTL ? "row" : "row",
      },

      // أيقونة النافذة المنبثقة
      modalIcon: {
        width: isMobile ? "48px" : "56px",
        height: isMobile ? "48px" : "56px",
        borderRadius: isMobile ? "12px" : "16px",
        background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        //boxShadow: "0 12px 30px rgba(59, 130, 246, 0.4)",
        flexShrink: 0,
      },

      // عنوان النافذة المنبثقة
      modalTitle: {
        fontSize: isMobile ? "20px" : "28px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        margin: 0,
        letterSpacing: "-0.01em",
        textAlign: isRTL ? "right" : "left",
      },

      // العنوان الفرعي للنافذة المنبثقة
      modalSubtitle: {
        fontSize: isMobile ? "13px" : "15px",
        color:
          theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
        margin: "4px 0 0 0",
        fontWeight: "500",
        textAlign: isRTL ? "right" : "left",
      },

      // زر الإغلاق
      closeButton: {
        background: "none",
        border: "none",
        color:
          theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.6)",
        cursor: "pointer",
        padding: isMobile ? "8px" : "12px",
        borderRadius: isMobile ? "8px" : "12px",
        transition: "all 0.2s ease",
        fontSize: isMobile ? "20px" : "24px",
        fontWeight: "300",
        flexShrink: 0,
      },

      // حاوية النموذج
      formContainer: {
        padding: isMobile ? "0 16px 16px" : "0 32px 32px",
        maxHeight: isMobile ? "calc(95vh - 120px)" : "calc(90vh - 120px)",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        WebkitOverflowScrolling: "touch",
      },

      // شبكة النموذج
      formGrid: {
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(0, 1fr))",
        gap: isMobile ? "12px" : "12px",
        alignItems: "start",
        columnGap: isMobile ? "12px" : "16px",
        marginBottom: isMobile ? "12px" : "16px",
      },

      // مجموعة النموذج
      formGroup: {
        marginBottom: isMobile ? "16px" : "20px",
      },

      // تسمية النموذج
      formLabel: {
        display: "block",
        fontSize: isMobile ? "13px" : "14px",
        fontWeight: "700",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        marginBottom: "8px",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        textAlign: isRTL ? "right" : "left",
      },

      // حقل إدخال النموذج
      formInput: {
        width: "100%",
        padding: isMobile ? "8px 12px" : "10px 14px",
        borderRadius: isMobile ? "10px" : "14px",
        border:
          theme === "dark"
            ? "2px solid rgba(255,255,255,0.12)"
            : "2px solid rgba(0,0,0,0.08)",
        background:
          theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        fontSize: isMobile ? "14px" : "15px",
        fontWeight: "500",
        outline: "none",
        transition: "all 0.3s ease",
        backdropFilter: "blur(10px)",
        boxSizing: "border-box",
        textAlign: isRTL ? "right" : "left",
        minHeight: "40px",
        display: "flex",
        alignItems: "center",
      },

      // حاوية الحقول الموحدة
      formInputWrapper: {
        width: "100%",
        minHeight: "40px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      },

      // منطقة النص
      formTextarea: {
        width: "100%",
        padding: isMobile ? "12px 16px" : "16px 20px",
        borderRadius: isMobile ? "10px" : "14px",
        border:
          theme === "dark"
            ? "2px solid rgba(255,255,255,0.12)"
            : "2px solid rgba(0,0,0,0.08)",
        background:
          theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        fontSize: isMobile ? "14px" : "15px",
        fontWeight: "500",
        outline: "none",
        resize: "vertical",
        minHeight: isMobile ? "80px" : "120px",
        fontFamily: "inherit",
        transition: "all 0.3s ease",
        backdropFilter: "blur(10px)",
        boxSizing: "border-box",
        textAlign: isRTL ? "right" : "left",
      },

      // قائمة منسدلة
      formSelect: {
        width: "100%",
        padding: isMobile ? "8px 12px" : "10px 14px",
        borderRadius: isMobile ? "10px" : "14px",
        border:
          theme === "dark"
            ? "2px solid rgba(255,255,255,0.12)"
            : "2px solid rgba(0,0,0,0.08)",

        background:
          theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        fontSize: isMobile ? "14px" : "15px",
        fontWeight: "500",
        outline: "none",
        cursor: "pointer",
        transition: "all 0.3s ease",
        backdropFilter: "blur(10px)",
        boxSizing: "border-box",
        textAlign: isRTL ? "right" : "left",
      },

      // إجراءات النموذج
      formActions: {
        display: "flex",
        flexDirection: isMobile ? "column" : isRTL ? "row-reverse" : "row",
        gap: isMobile ? "12px" : "16px",
        justifyContent: "flex-end",
        paddingTop: isMobile ? "16px" : "24px",
        borderTop:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(0,0,0,0.08)",
      },

      // حالة التحميل
      loadingOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: isMobile ? "16px" : "24px",
        backdropFilter: "blur(8px)",
        zIndex: 10,
      },

      // دوار التحميل
      loadingSpinner: {
        width: isMobile ? "32px" : "48px",
        height: isMobile ? "32px" : "48px",
        border: "4px solid rgba(255,255,255,0.2)",
        borderTop: "4px solid #2e7cba",
        borderRadius: "50%",

        animation: "spin 1s linear infinite",
      },

      // حالة فارغة
      emptyState: {
        padding: isMobile ? "40px 16px" : "80px 32px",
        textAlign: "center",
        color: theme === "dark" ? "rgba(255,255,255,0.6)" : "#6b7280",
      },

      // أيقونة الحالة الفارغة
      emptyIcon: {
        width: isMobile ? "64px" : "96px",
        height: isMobile ? "64px" : "96px",
        margin: "0 auto 16px",
        opacity: 0.6,
        color: theme === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
      },

      // عنوان الحالة الفارغة
      emptyTitle: {
        fontSize: isMobile ? "18px" : "24px",
        fontWeight: "700",
        color: theme === "dark" ? "rgba(255,255,255,0.8)" : "#374151",
        margin: "0 0 12px 0",
      },

      // وصف الحالة الفارغة
      emptyDescription: {
        fontSize: isMobile ? "14px" : "16px",
        opacity: 0.8,
        margin: 0,
        // marginBottom: "32px",
        lineHeight: "1.5",
      },
      emptyDescription1: {
        fontSize: isMobile ? "14px" : "16px",
        opacity: 0.8,
        margin: 0,
        marginBottom: "32px",
        lineHeight: "1.5",
      },
    };
  };
  // إضافة مهمة
  // const addTodo = (e) => {
  //   e.preventDefault();
  //   if (!newTodoText.trim()) return;
  //   const newTodo = {
  //     id: Date.now(),
  //     text: newTodoText.trim(),
  //     completed: false,
  //     category: todoCategory,
  //     createdAt: new Date().toISOString(),
  //   };
  //   setTodos([newTodo, ...todos]);
  //   setNewTodoText("");
  // };
  // ✅ ضيف الدالة دي
  // ✅ الدالة الصحيحة
  const addTodo = async (e) => {
    e.preventDefault();
    if (!newTodoText.trim()) return;

    try {
      const response = await apiFetch(`${BASE_URL}/todos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          infinityCode: currentInfinityCode,
          text: newTodoText.trim(),
          category: todoCategory,
        }),
      });

      const data = await response.json();
      setTodos([data.todo, ...todos]);
      setNewTodoText("");
    } catch (error) {
      console.error("Error adding todo:", error);
    }
  };

  // تبديل حالة المهمة
  // ✅ استبدل دالة toggleTodo بـ:
  const toggleTodo = async (id) => {
    try {
      const todo = todos.find((t) => t.id === id);
      const response = await apiFetch(`${BASE_URL}/todos/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ completed: !todo.completed }),
      });

      const data = await response.json();
      setTodos(todos.map((t) => (t.id === id ? data.todo : t)));
    } catch (error) {
      console.error("Error toggling todo:", error);
    }
  };

  // حذف مهمة
  const deleteTodo = async (id) => {
    try {
      await apiFetch(`${BASE_URL}/todos/${id}`, {
        method: "DELETE",
      });

      setTodos(todos.filter((t) => t.id !== id));
    } catch (error) {
      console.error("Error deleting todo:", error);
    }
    // ✅ استبدل دالة deleteTodo بـ:
  };

  // فلترة المهام
  const getFilteredTodos = () => {
    if (todoFilter === "active") return todos.filter(t => !t.completed);
    if (todoFilter === "completed") return todos.filter(t => t.completed);
    return todos;
  };

  // إحصائيات المهام
  const getTodoStats = () => {
    const total = todos.length;
    const completed = todos.filter(t => t.completed).length;
    const progress = total > 0 ? Math.round((completed / total) * 100) : 0;
    return { total, completed, active: total - completed, progress };
  };

  // ===============================================
  // HELPER FUNCTIONS - الوظائف المساعدة
  // ===============================================

  /**
   * تحميل اسم المنظم وحفظه في الذاكرة المؤقتة
   * @param {string} infinityCode - كود الموظف
   * @returns {Promise<string>} اسم الموظف
   */
  const loadOriginatorName = async (infinityCode) => {
    if (!infinityCode) return profile?.employeeName || localStorage.getItem('userName') || t.unknownUser;

    if (originatorNames[infinityCode]) {
      return originatorNames[infinityCode];
    }

    const name = await fetchEmployeeByInfinityCode(infinityCode);

    setOriginatorNames((prev) => ({
      ...prev,
      [infinityCode]: name,
    }));

    return name;
  };

  /**
   * جلب بيانات جميع الموظفين
   */
  const fetchAllEmployees = async () => {
    try {
      const response = await apiFetch(
        `${API_BASE.replace("/calendar", "")}/employees`,
        {
          method: "GET"
        }
      );
      const res = await response.json();

      console.log("Raw employee data:", res);

      let employees = [];
      if (Array.isArray(res)) {
        employees = res;
      } else if (res.data?.success && Array.isArray(res.data.data)) {
        employees = res.data.data;
      } else if (res.data?.employees && Array.isArray(res.data.employees)) {
        employees = res.data.employees;
      }

      const normalizedEmployees = employees
        .map((emp) => ({
          id: emp.id || emp.infinityCode,
          infinityCode: emp.infinityCode,
          name:
            emp.name ||
            emp.sr ||
            emp.arabicName ||
            emp.englishName ||
            t.unknownUser,
          email: emp.email,
          department: emp.department || "N/A",
          position: emp.position || emp.jobTitle || "N/A",
        }))
        .filter((emp) => emp.email);

      setEmployeeList(normalizedEmployees);
      console.log("Loaded employees:", normalizedEmployees.length);
    } catch (err) {
      console.error("Failed to fetch employees:", err);
      setEmployeeList([]);
    }
  };

  /**
   * جلب بيانات موظف بالكود
   * @param {string} infinityCode - كود الموظف
   * @returns {Promise<string>} اسم الموظف
   */
  const fetchEmployeeByInfinityCode = async (infinityCode) => {
    if (!infinityCode) return t.unknownUser;

    try {
      const response = await apiFetch(
        `${API_BASE.replace("/calendar", "")}/employees/select/${infinityCode}`,
        {
          method: "GET"
        }
      );
      const res = await response.json();

      if (res.data?.success && res.data.employee) {
        return (
          res.data.employee.name || res.data.employee.email || t.unknownUser
        );
      } else if (res.data?.name) {
        return res.data.name;
      }
    } catch (err) {
      console.error(
        `Failed to fetch employee with infinityCode ${infinityCode}:`,
        err
      );
    }
    return profile?.employeeName || localStorage.getItem('userName') || t.unknownUser;
  };

  /**
   * Ensure originator names are resolved for a list of UI events.
   * If an event lacks a proper originatorName, it will try to load it
   * and then update the `events` state with the resolved names.
   * @param {Array} uiEvents
   */
  const ensureOriginatorNamesForEvents = async (uiEvents = []) => {
    if (!Array.isArray(uiEvents) || uiEvents.length === 0) return;

    const updated = await Promise.all(
      uiEvents.map(async (ev) => {
        // if there's already a real name, skip
        if (ev.originatorName && ev.originatorName !== t.loading && ev.originatorName !== t.unknownUser) {
          return ev;
        }

        const code = ev.originatorCode || ev.infinityCode || null;
        const name = await loadOriginatorName(code);
        return {
          ...ev,
          originatorName: name,
        };
      })
    );

    setEvents(updated);
  };

  /**
   * التحقق من صحة عناوين البريد الإلكتروني
   * @param {string} emailString - سلسلة العناوين
   * @returns {Object} نتيجة التحقق
   */
  const validateEmails = (emailString) => {
    if (!emailString.trim()) return { isValid: true, emails: [] };

    const emails = emailString
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email.length > 0);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidEmails = emails.filter((email) => !emailRegex.test(email));

    return {
      isValid: invalidEmails.length === 0,
      emails: emails,
      invalidEmails: invalidEmails,
    };
  };

  /**
   * الحصول على الأحداث لتاريخ معين
   * @param {Date} date - التاريخ
   * @returns {Array} قائمة الأحداث
   */
  const getEventsForDate = (date) => {
    if (!date) return [];
    const dateString = formatDate(date);
    return events.filter(
      (ev) =>
        ev.date === dateString &&
        (filterType === "all" || ev.type === filterType)
    );
  };

  /**
   * الحصول على الأحداث القادمة
   * @returns {Array} قائمة الأحداث القادمة
   */
  const getUpcomingEvents = () => {
    const today = new Date();
    const nextWeek = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);

    return events
      .filter((event) => {
        if (filterType !== "all" && event.type !== filterType) return false;
        if (
          searchTerm &&
          !event.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
          return false;

        const eventDate = new Date(`${event.date}T00:00:00`);
        return eventDate >= today && eventDate <= nextWeek;
      })
      .sort((a, b) => new Date(a.date) - new Date(b.date))
      .slice(0, 8);
  };

  /**
   * الحصول على اقتراحات الموظفين
   * @returns {Array} قائمة اقتراحات الموظفين
   */
  const getEmployeeSuggestions = () => {
    if (!suggestionFilter || suggestionFilter.length < 1) return [];

    const currentAttendees = (formData.attendees || "")
      .split(",")
      .map((email) => email.trim().toLowerCase());
    const filter = suggestionFilter.toLowerCase();

    return employeeList
      .filter((emp) => {
        if (currentAttendees.includes(emp.email.toLowerCase())) return false;

        const matchesName = emp.name.toLowerCase().includes(filter);
        const matchesEmail = emp.email.toLowerCase().includes(filter);

        return matchesName || matchesEmail;
      })
      .slice(0, 8);
  };

  /**
   * الحصول على الأحرف الأولى للموظف
   * @param {Object} employee - بيانات الموظف
   * @returns {string} الأحرف الأولى
   */
  const getEmployeeInitials = (employee) => {
    if (employee.name && employee.name.trim().length > 0) {
      const parts = employee.name.trim().split(" ");
      if (parts.length === 1) return parts[0][0].toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    if (employee.email && employee.email.length > 0) {
      return employee.email[0].toUpperCase();
    }
    return "?";
  };

  /**
   * اختصار الاسم لعرض كلمة او كلمتين فقط
   * @param {string} name
   * @param {number} maxWords
   */
  const getShortName = (name, maxWords = 2) => {
    if (!name || typeof name !== 'string') return '';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    return parts.slice(0, Math.max(1, Math.min(maxWords, parts.length))).join(' ');
  };

  /**
   * الحصول على حالة RSVP للمستخدم الحالي
   * @param {Object} event - بيانات الحدث
   * @returns {string|null} حالة RSVP
   */
  const getCurrentUserRSVPStatus = (event) => {
    if (!currentInfinityCode || !event.raw?.attendees) return null;

    const currentUserCode = String(currentInfinityCode);
    const attendee = event.raw.attendees.find(
      (att) =>
        att.employeeId === currentUserCode ||
        att.employee?.infinityCode === currentUserCode
    );

    return attendee ? attendee.status : null;
  };

  // ===============================================
  // DATA CONVERSION FUNCTIONS - وظائف تحويل البيانات
  // ===============================================

  /**
   * الحصول على مصفوفة المدعوين من بيانات الخادم
   * @param {Object} ev - بيانات الحدث
   * @returns {Array} قائمة عناوين البريد الإلكتروني
   */
  const attendeesArrayFromBackend = (ev) => {
    if (!ev || ev.attendees == null) return [];

    if (typeof ev.attendees === "string") {
      try {
        const parsed = JSON.parse(ev.attendees);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        // not JSON, fallthrough
      }
    }

    if (Array.isArray(ev.attendees)) {
      return ev.attendees
        .map((a) => {
          if (!a) return null;
          if (typeof a === "string") return a;
          return a.user?.email || a.employee?.email || a.email || null;
        })
        .filter(Boolean);
    }

    if (typeof ev.attendees === "object") {
      const a = ev.attendees;
      return [a.user?.email || a.employee?.email || a.email].filter(Boolean);
    }

    return [];
  };

  /**
   * تحويل بيانات الخادم إلى واجهة المستخدم
   * @param {Object} ev - بيانات الحدث من الخادم
   * @returns {Object} بيانات الحدث للواجهة
   */
  const mapBackendToUI = (ev) => {
    const start = ev.start ? new Date(ev.start) : null;
    const end = ev.end ? new Date(ev.end) : null;
    const date = start ? formatDate(start) : null;
    const time = start ? start.toTimeString().slice(0, 5) : "";
    const duration =
      start && end
        ? Math.round((end - start) / (60 * 1000))
        : ev.duration || 60;

    const attendeesEmails = attendeesArrayFromBackend(ev);
    const attendeesString = attendeesEmails.join(", ");

    return {
      id: ev.id,
      title: ev.title,
      date,
      time,
      duration,
      type: ev.type || "meeting",
      location: ev.location || "",
      attendees: attendeesString,
      description: ev.description || "",
      priority: ev.priority || "medium",
      isRecurring: !!ev.recurrenceRule,
      recurrenceRule: ev.recurrenceRule || "",
      assignedBy: ev.assignedBy,
      status: ev.status || "scheduled",
      reminder: !!ev.reminder,
      color: eventTypes.find((t) => t.id === ev.type)?.color || "#2e7cba",
      raw: ev,
      originatorCode: ev.originatorCode || ev.infinityCode || null,
      originatorName: ev.originatorName || t.loading,
    };
  };

  /**
   * تحويل بيانات واجهة المستخدم إلى الخادم
   * @param {Object} ui - بيانات الحدث من الواجهة
   * @returns {Object} بيانات الحدث للخادم
   */
  const mapUIToBackend = (ui) => {
    const start =
      ui.date && ui.time ? new Date(`${ui.date}T${ui.time}:00`) : null;

    // Calculate end based on event type
    let end = null;

    // For vacations or events with explicit end dates, use endDate
    if (ui.endDate && (ui.type === "vacation" || ui.endDate !== ui.date)) {
      // Set end to end of day for multi-day events
      end = new Date(`${ui.endDate}T23:59:59`);
    }
    // For single-day events (meetings, etc.), calculate from duration
    else if (start) {
      end = new Date(start.getTime() + Number(ui.duration || 60) * 60000);
    }

    const attendeesArray = ui.attendees
      ? ui.attendees
        .split(",")
        .map((email) => (email || "").trim())
        .filter((email) => email.length > 0)
      : [];

    return {
      title: ui.title,
      description: ui.description,
      start: start ? start.toISOString() : null,
      end: end ? end.toISOString() : null,
      endDate: ui.endDate || null, // Include explicit end date
      type: ui.type,
      location: ui.location,
      priority: ui.priority,
      status: ui.status,
      reminder: !!ui.reminder,
      attendees: attendeesArray,
      recurrenceRule: ui.recurrenceRule || null,
      infinityCode: ui.infinityCode || currentInfinityCode || null,
      originatorCode: ui.originatorCode || currentInfinityCode || null,
      originatorName: ui.originatorName || null,
    };
  };

  // ===============================================
  // API FUNCTIONS - وظائف API
  // ===============================================

  /**
   * جلب الأحداث من الخادم
   */
  const fetchEvents = async () => {
    if (!currentInfinityCode) {
      setErrorMsg(t.noUserSession);
      return;
    }

    setLoading(true);
    setErrorMsg("");

    try {
      const url = `${API_BASE}/${currentInfinityCode}`;
      const response = await apiFetch(url, {
        method: "GET"
      });
      const res = await response.json();

      let eventsArray = [];

      if (Array.isArray(res)) {
        eventsArray = res;
      } else if (res.data?.success && Array.isArray(res.data.data)) {
        eventsArray = res.data.data;
      } else if (res.data?.data && Array.isArray(res.data.data)) {
        eventsArray = res.data.data;
      }

      if (eventsArray.length === 0) {
        setEvents([]);
        setErrorMsg(t.noEventsFound);
      } else {
        const uiEvents = eventsArray.map(mapBackendToUI);
        setEvents(uiEvents);
        updateCalendarStats(uiEvents);
        // Resolve any missing originator names asynchronously
        ensureOriginatorNamesForEvents(uiEvents).catch((err) => console.error('Failed to resolve originator names:', err));
      }
    } catch (err) {
      console.error("Failed to fetch events:", err);
      setErrorMsg(t.unableToLoad);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  /**
   * تحديث إحصائيات التقويم
   * @param {Array} eventList - قائمة الأحداث
   */
  const updateCalendarStats = (eventList = events) => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay());
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    const today = new Date().toDateString();

    const stats = {
      totalEvents: eventList.length,
      thisMonth: eventList.filter((e) => {
        const eventDate = new Date(e.date);
        return (
          eventDate.getMonth() === currentMonth &&
          eventDate.getFullYear() === currentYear
        );
      }).length,
      upcoming: eventList.filter((e) => new Date(e.date) > now).length,
      completed: eventList.filter((e) => e.status === "completed").length,
      meetings: eventList.filter((e) => e.type === "meeting").length,
      deadlines: eventList.filter((e) => e.type === "deadline").length,
      vacationDays: vacationDates.size,
      productivity: Math.min(
        95,
        70 +
        (eventList.filter((e) => e.status === "completed").length /
          Math.max(1, eventList.length)) *
        25
      ),
      weeklyHours: eventList
        .filter((e) => {
          const eventDate = new Date(e.date);
          return eventDate >= startOfWeek && eventDate <= endOfWeek;
        })
        .reduce((total, e) => total + e.duration / 60, 0),
      overdueEvents: eventList.filter(
        (e) => new Date(e.date) < now && e.status !== "completed"
      ).length,
      todayEvents: eventList.filter(
        (e) => new Date(e.date).toDateString() === today
      ).length,
      thisWeekEvents: eventList.filter((e) => {
        const eventDate = new Date(e.date);
        return eventDate >= startOfWeek && eventDate <= endOfWeek;
      }).length,
    };

    setCalendarStats(stats);
  };

  // ===============================================
  // EVENT HANDLERS - معالجات الأحداث
  // ===============================================

  /**
   * معالج النقر على التاريخ
   * @param {Date} date - التاريخ المحدد
   * @param {boolean} isShiftKey - مفتاح Shift مضغوط
   * @param {boolean} isCtrlKey - مفتاح Ctrl مضغوط
   */
  const handleDateClick = (date, isShiftKey = false, isCtrlKey = false) => {
    if (!date) return;

    // Normalize to midnight local time (fixes "next day" bug)
    const localDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const dateString = formatDate(localDate);

    if (dateRangeMode) {
      handleDateRangeClick(localDate, rangeType);
      return;
    }

    if (isCtrlKey) {
      const newSelectedDates = new Set(selectedDates);
      if (newSelectedDates.has(dateString)) {
        newSelectedDates.delete(dateString);
      } else {
        newSelectedDates.add(dateString);
      }
      setSelectedDates(newSelectedDates);
    } else if (isShiftKey && selectedDate) {
      // Normalize both dates to midnight local time
      const normalizedSelected = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      );
      const start =
        normalizedSelected <= localDate ? normalizedSelected : localDate;
      const end =
        normalizedSelected <= localDate ? localDate : normalizedSelected;
      const newSelectedDates = new Set();

      // Iterate through dates at midnight local time
      const currentDate = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate()
      );
      while (currentDate <= end) {
        newSelectedDates.add(formatDate(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }

      setSelectedDates(newSelectedDates);
    } else {
      setSelectedDate(localDate);
      setSelectedDates(new Set([dateString]));
    }
  };

  /**
   * معالج تحديد النطاق الزمني
   * @param {Date} date - التاريخ
   * @param {string} type - نوع النطاق
   */
  const handleDateRangeClick = (date, type = "events") => {
    if (!dateRangeMode) {
      setDateRangeMode(true);
      setDateRangeStart(date);
      setDateRangeEnd(null);
      setRangeType(type);
    } else {
      if (!dateRangeStart) {
        setDateRangeStart(date);
      } else if (!dateRangeEnd) {
        const start = dateRangeStart <= date ? dateRangeStart : date;
        const end = dateRangeStart <= date ? date : dateRangeStart;
        setDateRangeStart(start);
        setDateRangeEnd(end);

        if (type === "vacation") {
          applyVacationRange(start, end);
        } else {
          applyEventRange(start, end);
        }

        setDateRangeMode(false);
        setDateRangeStart(null);
        setDateRangeEnd(null);
      }
    }
  };

  /**
   * تطبيق نطاق الإجازة
   * @param {Date} start - تاريخ البداية
   * @param {Date} end - تاريخ النهاية
   */
  const applyVacationRange = (start, end) => {
    const newVacationDates = new Set(vacationDates);
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      newVacationDates.add(d.toISOString().split("T")[0]);
    }
    setVacationDates(newVacationDates);
    updateCalendarStats();
  };

  /**
   * تطبيق نطاق الأحداث
   * @param {Date} start - تاريخ البداية
   * @param {Date} end - تاريخ النهاية
   */
  const applyEventRange = (start, end) => {
    const newSelectedDates = new Set();
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      newSelectedDates.add(d.toISOString().split("T")[0]);
    }
    setSelectedDates(newSelectedDates);
  };

  /**
   * معالج تغيير الحضور
   * @param {Event} e - حدث التغيير
   */
  const handleAttendeesChange = (e) => {
    const { value } = e.target;

    setFormData((prev) => ({
      ...prev,
      attendees: value,
    }));

    // الحصول على آخر جزء بعد الفاصلة
    const parts = value.split(",");
    const currentPart = parts[parts.length - 1].trim();

    setSuggestionFilter(currentPart);

    // إظهار الاقتراحات لو في حاجة مكتوبة
    setShowSuggestions(currentPart.length > 0);

    // التحقق من صحة الإيميلات
    const validation = validateEmails(value);
    if (!validation.isValid && value.trim()) {
      setErrorMsg(
        `${language === "ar" ? "عناوين بريد إلكتروني غير صالحة: " : "Invalid email addresses: "}${validation.invalidEmails.join(", ")}`
      );
    } else {
      setErrorMsg("");
    }
  };

  /**
   * إضافة موظف من الاقتراحات
   * @param {Object} employee - بيانات الموظف
   */
  const addEmployeeFromSuggestion = (employee) => {
    const currentAttendees = formData.attendees || "";
    const parts = currentAttendees
      .split(",")
      .map((p) => p.trim())
      .filter((p) => p.length > 0);

    // إضافة الموظف الجديد بدون إزالة أي شيء
    parts.push(employee.email);

    // إضافة فاصلة ومسافة في النهاية عشان تقدر تكتب تاني
    const newValue = parts.join(", ") + ", "; // ⬅️ التعديل هنا

    setFormData((prev) => ({
      ...prev,
      attendees: newValue,
    }));

    // الحفاظ على القائمة المنسدلة مفتوحة لإضافة موظفين آخرين
    setShowSuggestions(true);
    setSuggestionFilter("");

    // التركيز على الحقل عشان تكمل كتابة
    setTimeout(() => {
      document.getElementById("attendees-input")?.focus();
    }, 0);
  };

  /**
   * معالج تغيير الإدخال
   * @param {Event} e - حدث التغيير
   */
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  /**
   * فتح نافذة إنشاء حدث جديد
   * @param {Date} date - التاريخ المحدد
   */
  const openCreateModal = async (date = new Date()) => {
    const d = formatDate(date);

    const currentUserCode =
      currentInfinityCode || localStorage.getItem("infinityCode");
    const originatorName = await loadOriginatorName(currentUserCode);

    const fallbackName =
      originatorName === t.unknownUser
        ? profile?.employeeName || localStorage.getItem("userName") || originatorName
        : originatorName;

    const currentUserEmail =
      profile?.employeeEmail || localStorage.getItem("userEmail") ||
      (employeeList.find((e) => String(e.infinityCode) === String(currentUserCode)) || {}).email ||
      "";

    setFormData({
      ...emptyForm,
      date: d,
      originatorName: fallbackName,
      originatorCode: currentUserCode || localStorage.getItem("infinityCode") || null,
      isOriginator: true,
      attendees: currentUserEmail ? currentUserEmail : "",
    });
    setSelectedEvent(null);
    setShowEventModal(true);
  };

  /**
   * فتح نافذة تعديل حدث
   * @param {Object} uiEvent - بيانات الحدث
   */
  const openEditModal = async (uiEvent) => {
    setSelectedEvent(uiEvent);

    const currentUserCode =
      currentInfinityCode || localStorage.getItem("infinityCode");
    const eventOriginatorCode = uiEvent.originatorCode || null;
    const isOriginator =
      eventOriginatorCode &&
      currentUserCode &&
      parseInt(eventOriginatorCode) === parseInt(currentUserCode);

    let originatorName = t.unknownUser;
    if (eventOriginatorCode) {
      originatorName = await loadOriginatorName(eventOriginatorCode);
    }

    setFormData({
      title: uiEvent.title,
      description: uiEvent.description,
      date: uiEvent.date,
      time: uiEvent.time,
      duration: uiEvent.duration,
      type: uiEvent.type,
      location: uiEvent.location,
      attendees: uiEvent.attendees || "",
      priority: uiEvent.priority || "medium",
      status: uiEvent.status || "scheduled",
      reminder: uiEvent.reminder || false,
      recurrenceRule: uiEvent.raw?.recurrenceRule || "",
      infinityCode: currentInfinityCode ?? null,
      id: uiEvent.id,
      originatorName: originatorName,
      originatorCode: eventOriginatorCode,
      isOriginator: isOriginator,
    });

    // If the current user is the originator but attendees list is empty,
    // include the organizer's email so attendance count shows 1.
    const currentUserEmail =
      profile?.employeeEmail || localStorage.getItem("userEmail") ||
      (employeeList.find((e) => String(e.infinityCode) === String(currentUserCode)) || {}).email ||
      "";

    if (isOriginator) {
      setFormData((prev) => ({
        ...prev,
        attendees: prev.attendees && prev.attendees.trim() ? prev.attendees : (currentUserEmail || prev.attendees),
      }));
    }

    setShowEventModal(true);
  };

  /**
   * معالج إنشاء أو تحديث حدث
   * @param {Event} e - حدث النموذج
   */
  const handleCreateOrUpdate = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    try {
      const backendPayload = mapUIToBackend(formData);

      if (formData.id) {
        await apiFetch(`${API_BASE}/${formData.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(backendPayload)
        });
      } else {
        await apiFetch(API_BASE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(backendPayload)
        });
      }


      setShowEventModal(false);
      await fetchEvents();

      if (notificationSettings.eventUpdates) {
        sendNotification({
          title: formData.id ? t.eventUpdated : t.eventCreated,
          message: `${formData.title} ${formData.id ? t.hasBeenUpdated : t.hasBeenCreated}`,
          type: "success",
        });
      }
    } catch (err) {
      console.error("Failed to create/update event:", err);
      setErrorMsg(err?.response?.data?.message || t.failedToSave);
    }
  };

  /**
   * معالج تحديث حالة الحدث
   * @param {string} eventId - معرف الحدث
   * @param {string} newStatus - الحالة الجديدة
   */
  const handleStatusUpdate = async (eventId, newStatus) => {
    if (!currentInfinityCode || !eventId) {
      setErrorMsg(t.missingInfo);
      return;
    }

    try {
      const response = await apiFetch(
        `${API_BASE}/events/${eventId}/rsvp/${currentInfinityCode}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            status: newStatus,
          })
        }
      );
      const data = await response.json();

      // Refresh events and close the modal regardless of duplicate/400 response
      // (backend now enforces single response). This ensures UI removes RSVP buttons.
      setShowEventModal(false);
      await fetchEvents();

      if (data?.success) {
        sendNotification({
          title: t.rsvpUpdated,
          message: `${t.responseUpdated} "${newStatus}"`,
          type: "success",
        });
      } else if (data?.message) {
        // show backend message (e.g., "You have already responded...")
        setErrorMsg(data.message);
      }
    } catch (err) {
      console.error("RSVP update failed:", err);
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        t.failedToUpdate;
      setErrorMsg(errorMessage);
    }
  };

  /**
   * معالج حذف حدث
   * @param {Object} uiEvent - بيانات الحدث
   */
  const handleDelete = async (uiEvent) => {
    if (!uiEvent || !uiEvent.id) return;
    // If the current user is the originator/issuer of the event, skip the confirmation dialog
    const issuerCode = uiEvent.originatorCode || uiEvent.infinityCode || '';
    const isIssuer = String(issuerCode) === String(currentInfinityCode);
    if (!isIssuer) {
      if (!window.confirm(`${t.deleteConfirm} "${uiEvent.title}"?`)) return;
    }

    try {
      await apiFetch(`${API_BASE}/${uiEvent.id}`, {
        method: "DELETE"
      });
      setEvents((prev) => prev.filter((ev) => ev.id !== uiEvent.id));
      setShowEventModal(false);

      if (notificationSettings.eventUpdates) {
        sendNotification({
          title: t.eventDeleted,
          message: `${uiEvent.title} ${t.hasBeenDeleted}`,
          type: "info",
        });
      }
    } catch (err) {
      console.error("Failed to delete event:", err);
      setErrorMsg(t.failedToDelete);
    }
  };

  // ===============================================
  // NAVIGATION FUNCTIONS - وظائف التنقل
  // ===============================================

  /**
   * الانتقال للشهر السابق
   */
  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };

  /**
   * الانتقال للشهر التالي
   */
  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  /**
   * الانتقال لليوم الحالي
   */
  const goToToday = () => {
    const today = new Date();
    setCurrentDate(today);
    setSelectedDate(today);
  };

  /**
   * الحصول على أيام الشهر
   * @param {Date} date - التاريخ
   * @returns {Array} قائمة الأيام
   */
  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1, 12); // noon local time
    const lastDay = new Date(year, month + 1, 0, 12);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];

    // أيام الشهر السابق
    const prevMonth = new Date(year, month - 1, 0, 12);
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      const day = new Date(year, month - 1, prevMonth.getDate() - i, 12);
      days.push({ date: day, isCurrentMonth: false, isPrevMonth: true });
    }

    // أيام الشهر الحالي
    for (let day = 1; day <= daysInMonth; day++) {
      const d = new Date(year, month, day, 12);
      days.push({ date: d, isCurrentMonth: true, isPrevMonth: false });
    }

    // أيام الشهر التالي لملء الشبكة
    const remainingDays = 42 - days.length; // 6 صفوف × 7 أيام
    for (let day = 1; day <= remainingDays; day++) {
      const d = new Date(year, month + 1, day, 12);
      days.push({ date: d, isCurrentMonth: false, isPrevMonth: false });
    }

    return days;
  };
  // مكون To-Do List
  const TodoListComponent = () => {
    const todoStats = getTodoStats();

    // ⬅️ Handler منفصل للـ modal
    const handleModalSubmit = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (newTodoText.trim()) {
        addTodo(e);
        setShowAddModal(false);
      }
    };

    return (
      <>
        {/* الهيدر - تصميم جديد كلياً */}
        <div style={{
          background: theme === "dark"
            ? "linear-gradient(145deg, #1e293b 0%, #0f172a 100%)"
            : "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
          padding: "28px",
          borderRadius: "20px",
          marginBottom: "24px",
          border: theme === "dark" ? "1px solid rgba(16, 185, 129, 0.15)" : "1px solid rgba(16, 185, 129, 0.1)",
          boxShadow: theme === "dark"
            ? "0 10px 40px rgba(0, 0, 0, 0.3)"
            : "0 10px 40px rgba(16, 185, 129, 0.08)",
          position: "relative",
          overflow: "hidden",
        }}>
          {/* Pattern Background */}
          <div style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "200px",
            height: "200px",
            background: "radial-gradient(circle, rgba(16, 185, 129, 0.1) 1px, transparent 1px)",
            backgroundSize: "20px 20px",
            opacity: 0.3,
          }} />

          {/* Wave Decoration */}
          <div style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "60px",
            background: "linear-gradient(135deg, rgba(16, 185, 129, 0.05), rgba(5, 150, 105, 0.08))",
            clipPath: "polygon(0 50%, 100% 0, 100% 100%, 0% 100%)",
          }} />

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: "24px",
            alignItems: "center",
            position: "relative",
            zIndex: 1,
          }}>
            {/* Left Side */}
            <div>
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginBottom: "12px",
              }}>
                {/* Icon Badge */}
                <div style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 8px 24px rgba(16, 185, 129, 0.4), inset 0 -2px 8px rgba(0,0,0,0.2)",
                  position: "relative",
                }}>
                  <CheckCircle size={28} color="#fff" strokeWidth={2.5} />
                  {/* Shine Effect on Icon */}
                  <div style={{
                    position: "absolute",
                    top: "8px",
                    left: "8px",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.3)",
                    filter: "blur(4px)",
                  }} />
                </div>

                <div>
                  <h3 style={{
                    fontSize: "26px",
                    fontWeight: "900",
                    background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    margin: 0,
                    lineHeight: 1,
                    letterSpacing: "-0.5px",
                  }}>
                    {t.todoList}
                  </h3>
                  <p style={{
                    fontSize: "13px",
                    color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)",
                    margin: "6px 0 0 0",
                    fontWeight: "500",
                  }}>
                    <span style={{ fontWeight: "700", color: "#2e7cba" }}>{todoStats.completed}</span> {t.of || "من"} {todoStats.total} {t.tasksCompleted || "مكتملة"}
                  </p>
                </div>
              </div>

              {/* Progress Bar */}
              <div style={{
                width: "100%",
                height: "8px",
                background: theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
                borderRadius: "10px",
                overflow: "hidden",
                position: "relative",
              }}>
                <div style={{
                  width: `${todoStats.progress}%`,
                  height: "100%",
                  background: "linear-gradient(90deg, #2e7cba, #2e7cba)",
                  borderRadius: "10px",
                  transition: "width 0.5s ease",
                  boxShadow: "0 0 10px rgba(16, 185, 129, 0.5)",
                  position: "relative",
                  overflow: "hidden",
                }}>
                  {/* Animated Shine on Progress Bar */}
                  <div style={{
                    position: "absolute",
                    top: 0,
                    left: "-100%",
                    width: "100%",
                    height: "100%",
                    background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
                    animation: "progressShine 2s infinite",
                  }} />
                </div>
              </div>
            </div>

            {/* Right Side - Circular Progress */}
            <div style={{
              position: "relative",
              width: "90px",
              height: "90px",
            }}>
              {/* Outer Ring */}
              <svg width="90" height="90" style={{ transform: "rotate(-90deg)" }}>
                {/* Background Circle */}
                <circle
                  cx="45"
                  cy="45"
                  r="38"
                  fill="none"
                  stroke={theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}
                  strokeWidth="8"
                />
                {/* Progress Circle */}
                <circle
                  cx="45"
                  cy="45"
                  r="38"
                  fill="none"
                  stroke="url(#gradient)"
                  strokeWidth="8"
                  strokeLinecap="round"
                  strokeDasharray={`${2 * Math.PI * 38}`}
                  strokeDashoffset={`${2 * Math.PI * 38 * (1 - todoStats.progress / 100)}`}
                  style={{
                    transition: "stroke-dashoffset 0.6s ease",
                    filter: "drop-shadow(0 0 8px rgba(16, 185, 129, 0.5))",
                  }}
                />
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#2e7cba" />
                    <stop offset="100%" stopColor="#2e7cba" />
                  </linearGradient>
                </defs>
              </svg>

              {/* Center Text */}
              <div style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
              }}>
                <div style={{
                  fontSize: "22px",
                  fontWeight: "900",
                  background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  lineHeight: 1,
                }}>
                  {todoStats.progress}%
                </div>
              </div>

              {/* Pulsing Ring */}
              <div style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "94px",
                height: "94px",
                borderRadius: "50%",
                border: "2px solid rgba(16, 185, 129, 0.3)",
                animation: "pulse 2s infinite",
              }} />
            </div>
          </div>
        </div>

        {/* زر Add Task - تصميم جديد */}
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowAddModal(true);
          }}
          style={{
            width: "100%",
            height: "56px",
            fontSize: "15px",
            fontWeight: "700",
            color: "#fff",
            background: "linear-gradient(135deg, #2e7cba 0%, #2e7cba 100%)",
            border: "none",
            borderRadius: "16px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "24px",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            boxShadow: "0 8px 24px rgba(16, 185, 129, 0.25), inset 0 -2px 8px rgba(0,0,0,0.1)",
            position: "relative",
            overflow: "hidden",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px) scale(1.01)";
            e.currentTarget.style.boxShadow = "0 12px 32px rgba(16, 185, 129, 0.35), inset 0 -2px 8px rgba(0,0,0,0.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0) scale(1)";
            e.currentTarget.style.boxShadow = "0 8px 24px rgba(16, 185, 129, 0.25), inset 0 -2px 8px rgba(0,0,0,0.1)";
          }}
        >
          <div style={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <Plus size={20} strokeWidth={3} />
          </div>
          <span>{t.addTask}</span>

          {/* Animated Background */}
          <div style={{
            position: "absolute",
            top: "-50%",
            left: "-50%",
            width: "200%",
            height: "200%",
            background: "radial-gradient(circle, rgba(255,255,255,0.1) 10%, transparent 10%)",
            backgroundSize: "20px 20px",
            animation: "moveBackground 20s linear infinite",
            opacity: 0.3,
          }} />
        </button>

        {/* Modal - نفس التصميم السابق */}
        {showAddModal && (
          <>
            <div
              onClick={(e) => {
                e.stopPropagation();
                setShowAddModal(false);
                setNewTodoText("");
              }}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.7)",
                backdropFilter: "blur(8px)",
                zIndex: 999,
                animation: "fadeIn 0.25s ease",
              }}
            />

            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                maxWidth: "540px",
                background: theme === "dark"
                  ? "linear-gradient(145deg, #1e293b 0%, #0f172a 100%)"
                  : "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
                borderRadius: "28px",
                padding: "36px",
                zIndex: 1000,
                boxShadow: theme === "dark"
                  ? "0 24px 80px rgba(0, 0, 0, 0.9), 0 0 0 1px rgba(16, 185, 129, 0.2)"
                  : "0 24px 80px rgba(16, 185, 129, 0.15), 0 0 0 1px rgba(16, 185, 129, 0.1)",
                animation: "modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
              }}
            >
              {/* Header */}
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "32px",
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                }}>
                  <div style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "14px",
                    background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(16, 185, 129, 0.4)",
                  }}>
                    <Plus size={24} color="#fff" strokeWidth={3} />
                  </div>
                  <h3 style={{
                    fontSize: "24px",
                    fontWeight: "900",
                    background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    margin: 0,
                  }}>
                    {t.addNewTask || "إضافة مهمة جديدة"}
                  </h3>
                </div>

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowAddModal(false);
                    setNewTodoText("");
                  }}
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "12px",
                    background: theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: theme === "dark" ? "#fff" : "#1a1a1a",
                    fontSize: "22px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(239, 68, 68, 0.15)";
                    e.currentTarget.style.color = "#ef4444";
                    e.currentTarget.style.transform = "rotate(90deg) scale(1.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)";
                    e.currentTarget.style.color = theme === "dark" ? "#fff" : "#1a1a1a";
                    e.currentTarget.style.transform = "rotate(0deg) scale(1)";
                  }}
                >
                  ✕
                </button>
              </div>

              {/* Form */}
              <form onSubmit={handleModalSubmit}>
                <div style={{ marginBottom: "24px" }}>
                  <label style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "700",
                    color: theme === "dark" ? "rgba(255,255,255,0.9)" : "rgba(0,0,0,0.85)",
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}>
                    <span style={{ fontSize: "18px" }}>📝</span>
                    {t.taskDescription || "وصف المهمة"}
                  </label>
                  <textarea
                    value={newTodoText}
                    onChange={(e) => {
                      e.stopPropagation();
                      setNewTodoText(e.target.value);
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                      if (e.key === 'Enter' && e.ctrlKey) {
                        handleModalSubmit(e);
                      }
                    }}
                    placeholder={t.typeTaskHere}
                    autoFocus
                    style={{
                      width: "100%",
                      minHeight: "140px",
                      padding: "18px",
                      fontSize: "15px",
                      fontWeight: "500",
                      border: theme === "dark"
                        ? "2px solid rgba(255,255,255,0.08)"
                        : "2px solid rgba(0,0,0,0.08)",
                      borderRadius: "16px",
                      background: theme === "dark" ? "rgba(255,255,255,0.03)" : "#fff",
                      color: theme === "dark" ? "#fff" : "#1a1a1a",
                      outline: "none",
                      resize: "vertical",
                      fontFamily: "inherit",
                      transition: "all 0.3s ease",
                      boxSizing: "border-box",
                      direction: language === 'ar' ? 'rtl' : 'ltr',
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#2e7cba";
                      e.target.style.boxShadow = "0 0 0 4px rgba(16, 185, 129, 0.1)";
                      e.target.style.background = theme === "dark" ? "rgba(255,255,255,0.05)" : "#fff";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";
                      e.target.style.boxShadow = "none";
                      e.target.style.background = theme === "dark" ? "rgba(255,255,255,0.03)" : "#fff";
                    }}
                  />
                </div>

                {/* Category */}
                <div style={{ marginBottom: "32px" }}>
                  <label style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "700",
                    color: theme === "dark" ? "rgba(255,255,255,0.9)" : "rgba(0,0,0,0.85)",
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}>
                    <span style={{ fontSize: "18px" }}>🏷️</span>
                    {t.category || "الفئة"}
                  </label>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "12px" }}>
                    {[
                      { value: "personal", label: t.personalTasks, icon: "📋", color: "#6366f1", bg: "rgba(99, 102, 241, 0.1)" },
                      { value: "work", label: t.workTasks, icon: "💼", color: "#f59e0b", bg: "rgba(245, 158, 11, 0.1)" },
                      { value: "urgent", label: t.urgentTasks, icon: "🔥", color: "#ef4444", bg: "rgba(239, 68, 68, 0.1)" }
                    ].map((cat) => (
                      <button
                        key={cat.value}
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setTodoCategory(cat.value);
                        }}
                        style={{
                          padding: "16px 12px",
                          fontSize: "13px",
                          fontWeight: "700",
                          color: todoCategory === cat.value ? "#fff" : cat.color,
                          background: todoCategory === cat.value
                            ? `linear-gradient(135deg, ${cat.color}, ${cat.color}dd)`
                            : cat.bg,
                          border: `2px solid ${todoCategory === cat.value ? cat.color : "transparent"}`,
                          borderRadius: "14px",
                          cursor: "pointer",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "8px",
                          boxShadow: todoCategory === cat.value ? `0 8px 24px ${cat.color}50` : "none",
                          transform: todoCategory === cat.value ? "scale(1.02)" : "scale(1)",
                        }}
                        onMouseEnter={(e) => {
                          if (todoCategory !== cat.value) {
                            e.currentTarget.style.transform = "translateY(-3px) scale(1.02)";
                            e.currentTarget.style.boxShadow = `0 6px 20px ${cat.color}30`;
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (todoCategory !== cat.value) {
                            e.currentTarget.style.transform = "translateY(0) scale(1)";
                            e.currentTarget.style.boxShadow = "none";
                          }
                        }}
                      >
                        <span style={{ fontSize: "26px" }}>{cat.icon}</span>
                        <span>{cat.label}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Buttons */}
                <div style={{ display: "flex", gap: "14px" }}>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowAddModal(false);
                      setNewTodoText("");
                    }}
                    style={{
                      flex: 1,
                      height: "52px",
                      fontSize: "15px",
                      fontWeight: "700",
                      color: theme === "dark" ? "#fff" : "#1a1a1a",
                      background: theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
                      border: "2px solid transparent",
                      borderRadius: "14px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = theme === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.08)";
                      e.currentTarget.style.borderColor = theme === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)";
                      e.currentTarget.style.borderColor = "transparent";
                    }}
                  >
                    {t.cancel || "إلغاء"}
                  </button>
                  <button
                    type="submit"
                    disabled={!newTodoText.trim()}
                    style={{
                      flex: 2,
                      height: "52px",
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "#fff",
                      background: newTodoText.trim()
                        ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
                        : "rgba(128,128,128,0.3)",
                      border: "none",
                      borderRadius: "14px",
                      cursor: newTodoText.trim() ? "pointer" : "not-allowed",
                      transition: "all 0.3s ease",
                      boxShadow: newTodoText.trim() ? "0 8px 24px rgba(16, 185, 129, 0.3)" : "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      opacity: newTodoText.trim() ? 1 : 0.5,
                    }}
                    onMouseEnter={(e) => {
                      if (newTodoText.trim()) {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 12px 32px rgba(16, 185, 129, 0.4)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (newTodoText.trim()) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 8px 24px rgba(16, 185, 129, 0.3)";
                      }
                    }}
                  >
                    <CheckCircle size={20} strokeWidth={2.5} /> {t.addTask}
                  </button>
                </div>
              </form>
            </div>

            <style>{`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translate(-50%, -45%) scale(0.9);
            }
            to {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1);
            }
          }
          @keyframes pulse {
            0%, 100% {
              transform: translate(-50%, -50%) scale(1);
              opacity: 0.6;
            }
            50% {
              transform: translate(-50%, -50%) scale(1.1);
              opacity: 0.3;
            }
          }
          @keyframes progressShine {
            0% { left: -100%; }
            100% { left: 200%; }
          }
          @keyframes moveBackground {
            0% { transform: translate(0, 0); }
            100% { transform: translate(20px, 20px); }
          }
          @keyframes slideInTask {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
          </>
        )}

        {/* الفلاتر - تصميم جديد */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "12px",
          marginBottom: "24px",
        }}>
          {[
            { key: "all", label: t.allTasks, count: todoStats.total, gradient: "linear-gradient(135deg, #3b82f6, #2563eb)" },
            { key: "active", label: t.activeTasks, count: todoStats.active, gradient: "linear-gradient(135deg, #f59e0b, #d97706)" },
            { key: "completed", label: t.completedTasks, count: todoStats.completed, gradient: "linear-gradient(135deg, #2e7cba, #2e7cba)" }
          ].map((filter) => (
            <button
              key={filter.key}
              onClick={() => setTodoFilter(filter.key)}
              style={{
                padding: "16px 12px",
                fontSize: "13px",
                fontWeight: "700",
                color: todoFilter === filter.key ? "#fff" : theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
                background: todoFilter === filter.key
                  ? filter.gradient
                  : theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
                border: todoFilter === filter.key
                  ? "none"
                  : theme === "dark" ? "2px solid rgba(255,255,255,0.1)" : "2px solid rgba(0,0,0,0.08)",
                borderRadius: "14px",
                cursor: "pointer",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                boxShadow: todoFilter === filter.key ? "0 6px 20px rgba(16, 185, 129, 0.3)" : "none",
                transform: todoFilter === filter.key ? "translateY(-2px)" : "translateY(0)",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                if (todoFilter !== filter.key) {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 4px 16px rgba(16, 185, 129, 0.2)";
                  e.currentTarget.style.borderColor = "#2e7cba";
                }
              }}
              onMouseLeave={(e) => {
                if (todoFilter !== filter.key) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)";
                }
              }}
            >
              {/* Badge للعدد */}
              {todoFilter === filter.key && (
                <div style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "11px",
                  fontWeight: "900",
                }}>
                  {filter.count}
                </div>
              )}

              <span style={{ fontSize: "20px" }}>{filter.icon}</span>
              <span style={{ fontSize: "13px" }}>{filter.label}</span>

              {todoFilter !== filter.key && (
                <span style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  opacity: 0.7,
                }}>
                  {filter.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* قائمة المهام - تصميم جديد كلياً */}
        <div style={{
          maxHeight: "450px",
          overflowY: "auto",
          paddingRight: "6px",
        }}>
          {getFilteredTodos().length === 0 ? (
            <div style={{
              textAlign: "center",
              padding: "60px 24px",
              background: theme === "dark"
                ? "linear-gradient(145deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))"
                : "linear-gradient(145deg, #ffffff, #f8fafc)",
              borderRadius: "20px",
              border: theme === "dark" ? "2px dashed rgba(255,255,255,0.1)" : "2px dashed rgba(0,0,0,0.1)",
              position: "relative",
              overflow: "hidden",
            }}>
              {/* Decorative Circle */}
              <div style={{
                position: "absolute",
                top: "-40px",
                right: "-40px",
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(16, 185, 129, 0.1), transparent)",
              }} />

              <div style={{
                width: "80px",
                height: "80px",
                margin: "0 auto 24px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, rgba(16, 185, 129, 0.15), rgba(5, 150, 105, 0.1))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}>
                <CheckCircle size={40} color="#2e7cba" strokeWidth={2} />

                {/* Pulse Effect */}
                <div style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  border: "2px solid rgba(16, 185, 129, 0.3)",
                  animation: "pulse 2s infinite",
                }} />
              </div>

              <h4 style={{
                fontSize: "20px",
                fontWeight: "800",
                color: theme === "dark" ? "#fff" : "#1a1a1a",
                margin: "0 0 12px 0",
              }}>
                {t.noTasks}
              </h4>
              <p style={{
                fontSize: "14px",
                color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)",
                margin: 0,
                maxWidth: "240px",
                marginLeft: "auto",
                marginRight: "auto",
              }}>
                {t.noTasksDescription}
              </p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {getFilteredTodos().map((todo, index) => (
                <div
                  key={todo.id}
                  style={{
                    padding: "18px",
                    borderRadius: "16px",
                    background: todo.completed
                      ? theme === "dark"
                        ? "linear-gradient(135deg, rgba(16, 185, 129, 0.08), rgba(5, 150, 105, 0.05))"
                        : "linear-gradient(135deg, rgba(16, 185, 129, 0.06), rgba(5, 150, 105, 0.03))"
                      : theme === "dark"
                        ? "linear-gradient(145deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))"
                        : "linear-gradient(145deg, #ffffff, #f8fafc)",
                    border: theme === "dark"
                      ? `2px solid ${todo.completed ? "rgba(16, 185, 129, 0.25)" : "rgba(255,255,255,0.08)"}`
                      : `2px solid ${todo.completed ? "rgba(16, 185, 129, 0.2)" : "rgba(0,0,0,0.06)"}`,
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    animation: `slideInTask 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) ${index * 0.06}s both`,
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateX(-6px) scale(1.01)";
                    e.currentTarget.style.boxShadow = "0 8px 28px rgba(16, 185, 129, 0.18)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateX(0) scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  {/* Decorative Line */}
                  <div style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: "4px",
                    background: todo.completed
                      ? "linear-gradient(180deg, #2e7cba, #2e7cba)"
                      : "transparent",
                    borderRadius: "0 4px 4px 0",
                  }} />

                  {/* Custom Checkbox */}
                  <div
                    onClick={() => toggleTodo(todo.id)}
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "10px",
                      border: `2.5px solid ${todo.completed ? "#2e7cba" : theme === "dark" ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.25)"}`,
                      background: todo.completed ? "linear-gradient(135deg, #2e7cba, #2e7cba)" : "transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      flexShrink: 0,
                      boxShadow: todo.completed ? "0 4px 12px rgba(16, 185, 129, 0.4)" : "none",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.15) rotate(5deg)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1) rotate(0deg)";
                    }}
                  >
                    {todo.completed && (
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M13 4L6 11L3 8"
                          stroke="#fff"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>

                  {/* Content */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      color: todo.completed
                        ? theme === "dark" ? "rgba(255,255,255,0.35)" : "rgba(0,0,0,0.35)"
                        : theme === "dark" ? "#fff" : "#1a1a1a",
                      textDecoration: todo.completed ? "line-through" : "none",
                      marginBottom: "8px",
                      wordBreak: "break-word",
                      lineHeight: "1.4",
                    }}>
                      {todo.text}
                    </div>

                    {/* Category Badge */}
                    <div style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "5px 12px",
                      borderRadius: "10px",
                      fontSize: "11px",
                      fontWeight: "700",
                      background:
                        todo.category === "work" ? "linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(217, 119, 6, 0.1))" :
                          todo.category === "urgent" ? "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(220, 38, 38, 0.1))" :
                            "linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(79, 70, 229, 0.1))",
                      color:
                        todo.category === "work" ? "#f59e0b" :
                          todo.category === "urgent" ? "#ef4444" :
                            "#6366f1",
                      border: `1px solid ${todo.category === "work" ? "rgba(245, 158, 11, 0.3)" :
                        todo.category === "urgent" ? "rgba(239, 68, 68, 0.3)" :
                          "rgba(99, 102, 241, 0.3)"
                        }`,
                    }}>
                      <span style={{ fontSize: "14px" }}>
                        {todo.category === "work" ? "💼" : todo.category === "urgent" ? "🔥" : "📋"}
                      </span>
                      <span>
                        {todo.category === "work" ? t.workTasks : todo.category === "urgent" ? t.urgentTasks : t.personalTasks}
                      </span>
                    </div>
                  </div>

                  {/* Delete Button */}
                  <button
                    onClick={() => deleteTodo(todo.id)}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08))",
                      border: "1px solid rgba(239, 68, 68, 0.2)",
                      color: "#ef4444",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      flexShrink: 0,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "linear-gradient(135deg, rgba(239, 68, 68, 0.25), rgba(220, 38, 38, 0.15))";
                      e.currentTarget.style.transform = "scale(1.15) rotate(-5deg)";
                      e.currentTarget.style.boxShadow = "0 4px 16px rgba(239, 68, 68, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08))";
                      e.currentTarget.style.transform = "scale(1) rotate(0deg)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <Trash2 size={18} strokeWidth={2} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </>
    );


  };


  // ===============================================
  // NOTIFICATION FUNCTIONS - وظائف الإشعارات
  // ===============================================

  /**
   * إرسال إشعار
   * @param {Object} notification - بيانات الإشعار
   */
  const sendNotification = (notification) => {
    if (notificationSettings.pushNotifications && "Notification" in window) {
      new Notification(notification.title, {
        body: notification.message,
        icon: "/favicon.ico",
      });
    }

    setNotifications((prev) => [
      {
        id: Date.now(),
        ...notification,
        time: new Date(),
        read: false,
      },
      ...prev,
    ]);
  };

  /**
   * تحميل الإشعارات
   */
  const loadNotifications = () => {
    const mockNotifications = [
      {
        id: 1,
        type: "reminder",
        title: language === "ar" ? "اجتماع خلال 30 دقيقة" : "Meeting in 30 minutes",
        message: language === "ar" ? "اجتماع الفريق يبدأ الساعة 10:00 صباحًا" : "Team standup meeting starts at 10:00 AM",
        time: new Date(),
        priority: "high",
        read: false,
      },
      {
        id: 2,
        type: "deadline",
        title: language === "ar" ? "الموعد النهائي يقترب" : "Project deadline approaching",
        message: language === "ar" ? "تقرير الربع الأول مستحق غدًا" : "Q1 Report due tomorrow",
        time: new Date(Date.now() - 2 * 60 * 60 * 1000),
        priority: "urgent",
        read: false,
      },
    ];
    setNotifications(mockNotifications);
  };

  // ===============================================
  // ANIMATION FUNCTIONS - وظائف الرسوم المتحركة
  // ===============================================

  /**
   * معالج تمرير البطاقة
   * @param {Event} e - حدث التمرير
   * @param {boolean} isEntering - دخول أم خروج
   */
  const handleCardHover = (e, isEntering) => {
    if (isEntering) {
      Object.assign(e.currentTarget.style, {
        transform: "translateY(-8px) scale(1.02)",
        boxShadow:
          theme === "dark"
            ? "0 32px 64px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.15)"
            : "0 32px 64px rgba(0,0,0,0.2)",
      });
    } else {
      Object.assign(e.currentTarget.style, {
        transform: "translateY(0) scale(1)",
        boxShadow:
          theme === "dark"
            ? "0 20px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 20px 40px rgba(0,0,0,0.12)",
      });
    }
  };

  /**
   * معالج تمرير الزر
   * @param {Event} e - حدث التمرير
   * @param {boolean} isEntering - دخول أم خروج
   * @param {string} variant - نوع الزر
   */
  const handleButtonHover = (e, isEntering, variant = "default") => {
    if (isEntering) {
      switch (variant) {
        case "primary":
          Object.assign(e.currentTarget.style, {
            transform: "translateY(-3px) scale(1.05)",
            boxShadow: "0 15px 40px rgba(59, 130, 246, 0.5)",
          });
          break;
        case "success":
          Object.assign(e.currentTarget.style, {
            transform: "translateY(-3px) scale(1.05)",
            boxShadow: "0 15px 40px rgba(16, 185, 129, 0.5)",
          });
          break;
        default:
          Object.assign(e.currentTarget.style, {
            transform: "translateY(-2px) scale(1.03)",
            background:
              theme === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.08)",
          });
      }
    } else {
      Object.assign(e.currentTarget.style, {
        transform: "translateY(0) scale(1)",
        boxShadow:
          variant === "default"
            ? "none"
            : variant === "primary"
              ? "0 8px 25px rgba(59, 130, 246, 0.4)"
              : "0 8px 25px rgba(16, 185, 129, 0.4)",
        background:
          variant === "default"
            ? theme === "dark"
              ? "rgba(255,255,255,0.08)"
              : "rgba(0,0,0,0.06)"
            : undefined,
      });
    }
  };

  // ===============================================
  // FORM DATA - بيانات النموذج
  // ===============================================
  const emptyForm = {
    title: "",
    description: "",
    date: new Date().toISOString().split("T")[0],
    time: "09:00",
    duration: 60,
    type: "meeting",
    location: "",
    attendees: "",
    priority: "medium",
    status: "scheduled",
    reminder: false,
    recurrenceRule: "",
    infinityCode: currentInfinityCode || null,
    id: null,
  };

  const [formData, setFormData] = useState(emptyForm);

  // ===============================================
  // CONSTANTS - الثوابت
  // ===============================================
  const monthNames = language === "ar"
    ? [t.january, t.february, t.march, t.april, t.may, t.june, t.july, t.august, t.september, t.october, t.november, t.december]
    : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const dayNames = language === "ar"
    ? [t.sun, t.mon, t.tue, t.wed, t.thu, t.fri, t.sat]
    : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // ===============================================
  // EFFECTS - التأثيرات
  // ===============================================

  // تحميل البيانات عند بدء التشغيل
  useEffect(() => {
    fetchEvents();
    fetchAllEmployees();
  }, [currentInfinityCode]);

  // تأثيرات الرسوم المتحركة
  useEffect(() => {
    setTimeout(() => setAnimatedStats(true), 300);
    updateCalendarStats();
    loadNotifications();
  }, [events]);

  // ===============================================
  // COMPUTED VALUES - القيم المحسوبة
  // ===============================================
  const styles = getResponsiveStyles();
  const filteredUpcomingEvents = getUpcomingEvents();
  const eventCounts = eventTypes.reduce((acc, type) => {
    acc[type.id] =
      type.id === "all"
        ? events.length
        : events.filter((e) => e.type === type.id).length;
    return acc;
  }, {});

  // بيانات الإحصائيات المحسنة
  const enhancedStats = [
    {
      label: t.totalEvents,
      value: calendarStats.totalEvents,
      color: "#2e7cba",
      icon: CalendarIcon,
      //change: "+12%",
      isPositive: true,
    },
    {
      label: t.thisMonth,
      value: calendarStats.thisMonth,
      color: "#2e7cba",
      icon: TrendingUp,
      //change: "+8%",
      isPositive: true,
    },
    {
      label: t.todayEvents,
      value: calendarStats.todayEvents,
      color: "#f59e0b",
      icon: Clock,
      //change: "+3",
      isPositive: true,
    },
    {
      label: t.thisWeek,
      value: calendarStats.thisWeekEvents,
      color: "#8b5cf6",
      icon: CalendarDays,
      //change: "+7",
      isPositive: true,
    },
    {
      label: t.upcoming,
      value: calendarStats.upcoming,
      color: "#06b6d4",
      icon: Target,
      //change: "+15%",
      isPositive: true,
    },
    {
      label: t.completed,
      value: calendarStats.completed,
      color: "#84cc16",
      icon: CheckCircle,
      //change: "+23%",
      isPositive: true,
    },
    {
      label: t.overdue,
      value: calendarStats.overdueEvents,
      color: "#ef4444",
      icon: AlertCircle,
      //change: "-2",
      isPositive: true,
    },
    {
      label: t.weeklyHours,
      value: `${calendarStats.weeklyHours}${language === "ar" ? "ساعه " : "h"}`,
      color: "#2e7cba",
      icon: Timer,
      //change: "+2.5h",
      isPositive: true,
    },
    {
      label: t.meetings,
      value: calendarStats.meetings,
      color: "#ec4899",
      icon: Users,
      //change: "+5%",
      isPositive: true,
    },
    {
      label: t.deadlines,
      value: calendarStats.deadlines,
      color: "#f97316",
      icon: AlertCircle,
      //change: "-3%",
      isPositive: false,
    },
    {
      label: t.vacationDays,
      value: calendarStats.vacationDays,
      color: "#14b8a6",
      icon: Sun,
      //change: "+2 " + (language === "ar" ? "أيام" : "days"),
      isPositive: true,
    },
    {
      label: t.productivity,
      value: `${calendarStats.productivity}%`,
      color: "#a855f7",
      icon: Activity,
      //change: "+5%",
      isPositive: true,
    },
  ];

  // ===============================================
  // MODAL COMPONENTS - مكونات النوافذ المنبثقة
  // ===============================================
  /**
   * محتوى النافذة المنبثقة للحدث
   */
  const renderModalContent = () => {
    const isOriginator = formData.isOriginator;
    const isEditing = !!selectedEvent;
    const eventType = formData.type;

    // Determine field requirements based on event type
    const getEventTypeConfig = () => {
      switch (eventType) {
        case "vacation":
          return {
            showTime: false,
            showDuration: false,
            showEndDate: true,
            endDateRequired: true,
            showLocation: false,
            showAttendees: false,
            showRecurrence: false,
            showReminder: true,
            defaultDuration: 480, // All day
            timeLabel: t.startTime,
            endDateLabel: t.endDate,
            endDateDescription: t.lastDayVacation,
          };
        case "deadline":
          return {
            showTime: true,
            showDuration: false,
            showEndDate: false,
            endDateRequired: false,
            showLocation: false,
            showAttendees: true,
            showRecurrence: false,
            showReminder: true,
            defaultDuration: 0,
            timeLabel: t.dueTime,
            endDateLabel: t.endDate,
            endDateDescription: t.extendedDeadline,
          };
        case "meeting":
        case "training":
        case "interview":
        case "review":
        case "conference":
          return {
            showTime: true,
            showDuration: true,
            showEndDate: false,
            endDateRequired: false,
            showLocation: true,
            showAttendees: true,
            showRecurrence: true,
            showReminder: true,
            defaultDuration: 60,
            timeLabel: t.startTime,
            endDateLabel: t.endDate,
            endDateDescription: t.multiDayEnd,
          };
        case "social":
          return {
            showTime: true,
            showDuration: true,
            showEndDate: false,
            endDateRequired: false,
            showLocation: true,
            showAttendees: true,
            showRecurrence: false,
            showReminder: true,
            defaultDuration: 120,
            timeLabel: t.startTime,
            endDateLabel: t.endDate,
            endDateDescription: t.multiDayEnd,
          };
        default:
          return {
            showTime: true,
            showDuration: true,
            showEndDate: false,
            endDateRequired: false,
            showLocation: true,
            showAttendees: true,
            showRecurrence: true,
            showReminder: true,
            defaultDuration: 60,
            timeLabel: t.startTime,
            endDateLabel: t.endDate,
            endDateDescription: t.multiDayEnd,
          };
      }
    };

    const eventConfig = getEventTypeConfig();

    // Handle event type change
    const handleEventTypeChange = (e) => {
      const newType = e.target.value;
      const newConfig = getEventTypeConfig(newType);

      setFormData((prev) => ({
        ...prev,
        type: newType,
        duration: newConfig.defaultDuration || prev.duration,
        // Reset end date if not needed for new type
        endDate: newConfig.showEndDate ? prev.endDate : prev.date,
      }));
    };

    // local validation: end date should not be before start date
    const dateRangeInvalid =
      formData.endDate && formData.date && formData.endDate < formData.date;

    return (
      <>
        {/* رأس النافذة المنبثقة */}
        <div style={styles.modalHeader}>
          <div style={styles.modalTitleSection}>
            <div style={styles.modalIcon}>
              <CalendarIcon size={screenSize.isMobile ? 24 : 28} />
            </div>
            <div>
              <h2 style={styles.modalTitle}>
                {isEditing
                  ? isOriginator
                    ? t.editEvent
                    : t.viewEventDetails
                  : t.createNewEvent}
              </h2>
              <p style={styles.modalSubtitle}>
                {isEditing && !isOriginator && formData.originatorName && formData.originatorName !== t.unknownUser
                  ? `${t.eventOrganizedBy} ${getShortName(formData.originatorName, 2)} (${t.organizer})`
                  : isEditing
                    ? t.updateEventDetails
                    : `${t.addNewEvent} ${eventTypes
                      .find((type) => type.id === eventType)
                      ?.name?.toLowerCase() || (language === "ar" ? "حدث" : "event")
                    } ${t.toYourCalendar}`}
              </p>
            </div>
          </div>
          <button
            style={styles.closeButton}
            onClick={() => setShowEventModal(false)}
            onMouseEnter={(e) => handleButtonHover(e, true)}
            onMouseLeave={(e) => handleButtonHover(e, false)}
          >
            <X size={screenSize.isMobile ? 20 : 24} />
          </button>
        </div>

        {/* النموذج المحسن */}
        <form onSubmit={handleCreateOrUpdate} style={styles.formContainer}>
          {/* عرض معلومات المنظم للحضور */}
          {isEditing && !isOriginator && (
            <div
              style={{
                padding: screenSize.isMobile ? "8px 12px" : "10px 14px",
                borderRadius: screenSize.isMobile ? "10px" : "14px",
                background:
                  theme === "dark"
                    ? "rgba(59, 130, 246, 0.1)"
                    : "rgba(59, 130, 246, 0.05)",
                border: "2px solid rgba(59, 130, 246, 0.2)",
                marginBottom: screenSize.isMobile ? "12px" : "18px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexDirection: language === "ar" ? "row-reverse" : "row",
              }}
            >
              <Users size={20} style={{ color: "#2e7cba" }} />
              <div style={{ textAlign: language === "ar" ? "right" : "left" }}>
                <div
                  style={{
                    fontWeight: "600",
                    color: theme === "dark" ? "#fff" : "#1a1a1a",
                    marginBottom: "4px",
                    fontSize: screenSize.isMobile ? "14px" : "16px",
                  }}
                >
                  {t.organizedBy} {formData.originatorName}
                </div>
                <div
                  style={{
                    fontSize: screenSize.isMobile ? "12px" : "14px",
                    color:
                      theme === "dark"
                        ? "rgba(255,255,255,0.7)"
                        : "rgba(26,26,26,0.6)",
                  }}
                >
                  {t.youAreAttendee}
                </div>
              </div>
            </div>
          )}

          {/* حالة RSVP الحالية */}
          {isEditing && !isOriginator && (
            <div
              style={{
                padding: screenSize.isMobile ? "12px 16px" : "16px 20px",
                borderRadius: screenSize.isMobile ? "10px" : "14px",
                background:
                  theme === "dark"
                    ? "rgba(16, 185, 129, 0.1)"
                    : "rgba(16, 185, 129, 0.05)",
                border: "2px solid rgba(16, 185, 129, 0.2)",
                marginBottom: screenSize.isMobile ? "16px" : "24px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexDirection: language === "ar" ? "row-reverse" : "row",
              }}
            >
              <Check size={20} style={{ color: "#2e7cba" }} />
              <div style={{ textAlign: language === "ar" ? "right" : "left" }}>
                <div
                  style={{
                    fontWeight: "600",
                    color: theme === "dark" ? "#fff" : "#1a1a1a",
                    marginBottom: "4px",
                    fontSize: screenSize.isMobile ? "14px" : "16px",
                  }}
                >
                  {t.yourCurrentRSVP}{" "}
                  {getCurrentUserRSVPStatus(selectedEvent) || t.noResponse}
                </div>
                <div
                  style={{
                    fontSize: screenSize.isMobile ? "12px" : "14px",
                    color:
                      theme === "dark"
                        ? "rgba(255,255,255,0.7)"
                        : "rgba(26,26,26,0.6)",
                  }}
                >
                  {t.updateResponse}
                </div>
              </div>
            </div>
          )}

          {/* عنوان الحدث */}
          <div style={styles.formGroup || { marginBottom: screenSize.isMobile ? "16px" : "20px" }}>
            <label style={styles.formLabel}>{t.eventTitle}</label>
            <input
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              style={{
                ...styles.formInput,
                ...unifiedControlStyle(theme, language === 'ar'),
                background:
                  !isOriginator && isEditing
                    ? theme === "dark"
                      ? "rgba(255,255,255,0.06)"
                      : "rgba(255,255,255,0.5)"
                    : styles.formInput.background,
              }}
              placeholder={`${t.enterEventTitle} ${eventTypes
                .find((type) => type.id === eventType)
                ?.name?.toLowerCase() || (language === "ar" ? "حدث" : "event")
                } ${t.title}`}
              disabled={!isOriginator && isEditing}
              required
            />
          </div>

          {/* الوصف */}
          <div style={styles.formGroup || { marginBottom: screenSize.isMobile ? "16px" : "20px" }}>
            <label style={styles.formLabel}>{t.description}</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              style={{
                ...styles.formTextarea,
                ...unifiedControlStyle(theme, language === 'ar'),
                minHeight: screenSize.isMobile ? 100 : 120,
                background:
                  !isOriginator && isEditing
                    ? theme === "dark"
                      ? "rgba(255,255,255,0.06)"
                      : "rgba(255,255,255,0.5)"
                    : styles.formTextarea.background,
              }}
              placeholder={
                eventType === "vacation"
                  ? t.addVacationNotes
                  : eventType === "deadline"
                    ? t.addProjectDetails
                    : t.addDetailedDescription
              }
              disabled={!isOriginator && isEditing}
            />
          </div>

          {/* التاريخ والوقت الديناميكي */}
          <div style={styles.formGrid}>
            {/* Start Date - Always shown */}
            <div>
              <label style={styles.formLabel}>
                {eventType === "vacation" ? t.startDate : t.date}
              </label>
              <input
                name="date"
                type="date"
                value={formData.date}
                onChange={(e) => {
                  handleInputChange(e);
                  // If there's no endDate or endDate is before new start, update endDate to match start
                  const newStart = e.target.value;
                  if (
                    (!formData.endDate || formData.endDate < newStart) &&
                    eventConfig.showEndDate
                  ) {
                    setFormData((prev) => ({ ...prev, endDate: newStart }));
                  }
                }}
                style={{
                  ...styles.formInput,
                  ...unifiedControlStyle(theme, language === 'ar'),
                  background:
                    !isOriginator && isEditing
                      ? theme === "dark"
                        ? "rgba(255,255,255,0.06)"
                        : "rgba(255,255,255,0.5)"
                      : styles.formInput.background,
                }}
                disabled={!isOriginator && isEditing}
                required
              />
            </div>

            {/* End Date - Conditionally shown */}
            {eventConfig.showEndDate && (
              <div>
                <label style={styles.formLabel}>
                  {eventConfig.endDateLabel}
                  {eventConfig.endDateRequired && " *"}
                </label>
                <input
                  name="endDate"
                  type="date"
                  value={formData.endDate || formData.date}
                  onChange={handleInputChange}
                  min={formData.date || undefined}
                  style={{
                    ...styles.formInput,
                    ...unifiedControlStyle(theme, language === 'ar'),
                    background:
                      !isOriginator && isEditing
                        ? theme === "dark"
                          ? "rgba(255,255,255,0.06)"
                          : "rgba(255,255,255,0.5)"
                        : styles.formInput.background,
                  }}
                  disabled={!isOriginator && isEditing}
                  required={eventConfig.endDateRequired}
                />
                {eventConfig.endDateDescription && (
                  <div
                    style={{
                      fontSize: screenSize.isMobile ? 11 : 12,
                      color:
                        theme === "dark"
                          ? "rgba(255,255,255,0.5)"
                          : "rgba(0,0,0,0.5)",
                      marginTop: 6,
                      textAlign: language === "ar" ? "right" : "left",
                    }}
                  >
                    {eventConfig.endDateDescription}
                  </div>
                )}
              </div>
            )}

            {/* Time - Conditionally shown */}
            {eventConfig.showTime && (
              <div>
                <label style={styles.formLabel}>{eventConfig.timeLabel}</label>
                <input
                  name="time"
                  type="time"
                  value={formData.time}
                  onChange={handleInputChange}
                  style={{
                    ...styles.formInput,
                    ...unifiedControlStyle(theme, language === 'ar'),
                    background:
                      !isOriginator && isEditing
                        ? theme === "dark"
                          ? "rgba(255,255,255,0.06)"
                          : "rgba(255,255,255,0.5)"
                        : styles.formInput.background,
                  }}
                  disabled={!isOriginator && isEditing}
                  required={eventConfig.showTime}
                />
              </div>
            )}

            {/* Duration - Conditionally shown */}
            {eventConfig.showDuration && (
              <div>
                <label style={styles.formLabel}>{t.duration}</label>
                <div style={styles.formInputWrapper}>
                  <ReusableDropdown
                    items={[
                      { id: 15, name: `15 ${t.minutes}` },
                      { id: 30, name: `30 ${t.minutes}` },
                      { id: 45, name: `45 ${t.minutes}` },
                      { id: 60, name: `1 ${t.hour}` },
                      { id: 90, name: `1.5 ${t.hours}` },
                      { id: 120, name: `2 ${t.hours}` },
                      { id: 180, name: `3 ${t.hours}` },
                      { id: 240, name: `4 ${t.hours}` },
                      { id: 480, name: t.allDay },
                    ]}
                    value={formData.duration}
                    onSelect={(item) => {
                      const value = typeof item === 'string' ? item : item?.id || String(item);
                      handleInputChange({ target: { name: 'duration', value } });
                    }}
                    getItemKey={(it) => String(it.id)}
                    getItemLabel={(it) => it.name}
                    placeholder={t.duration}
                    theme={theme}
                    language={language}
                    maxItems={10}
                    disabled={!isOriginator && isEditing}
                    inputStyle={{
                      ...unifiedControlStyle(theme, language === 'ar'),
                      padding: screenSize.isMobile ? "12px 16px" : "16px 20px",
                      borderRadius: screenSize.isMobile ? "10px" : "14px",
                      width: "100%",
                      boxSizing: "border-box",
                      border: theme === "dark"
                        ? "2px solid rgba(255,255,255,0.12)"
                        : "2px solid rgba(0,0,0,0.08)",
                      background: theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
                    }}
                  />
                </div>
              </div>

            )}

            <div>
              <label style={styles.formLabel}>{t.priority}</label>
              <div style={styles.formInputWrapper}>
                <ReusableDropdown
                  items={[
                    { id: 'low', name: t.lowPriority },
                    { id: 'medium', name: t.mediumPriority },
                    { id: 'high', name: t.highPriority },
                    { id: 'urgent', name: t.urgent },
                  ]}
                  value={formData.priority}
                  onSelect={(item) => {
                    const value = typeof item === 'string' ? item : item?.id || String(item);
                    handleInputChange({ target: { name: 'priority', value } });
                  }}
                  getItemKey={(it) => it.id}
                  getItemLabel={(it) => it.name}
                  placeholder={t.priority}
                  theme={theme}
                  language={language}
                  maxItems={6}
                  disabled={!isOriginator && isEditing}
                  inputStyle={{
                    ...unifiedControlStyle(theme, language === 'ar'),
                    padding: screenSize.isMobile ? "12px 16px" : "16px 20px",
                    borderRadius: screenSize.isMobile ? "10px" : "14px",
                    width: "100%",
                    boxSizing: "border-box",
                    border: theme === "dark"
                      ? "2px solid rgba(255,255,255,0.12)"
                      : "2px solid rgba(0,0,0,0.08)",
                    background: theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
                  }}
                />
              </div>
            </div>

            {/* الحالة */}
            <div style={styles.formGroup || { marginBottom: screenSize.isMobile ? "16px" : "20px" }}>
              <label style={styles.formLabel}>
                {!isOriginator && isEditing ? t.yourStatus : t.status}
              </label>
              <div style={styles.formInputWrapper}>
                <ReusableDropdown
                  items={!isOriginator && isEditing
                    ? [
                      { id: 'accepted', name: t.accepted },
                      { id: 'declined', name: t.declined },
                      { id: 'tentative', name: t.tentative },
                      { id: 'no-response', name: t.noResponse },
                    ]
                    : [
                      { id: 'scheduled', name: t.scheduled },
                      { id: 'confirmed', name: t.confirmed },
                      { id: 'in-progress', name: t.inProgress },
                      { id: 'completed', name: t.completed },
                      { id: 'cancelled', name: t.cancelled },
                      { id: 'postponed', name: t.postponed },
                    ]}
                  value={formData.status}
                  onSelect={(item) => {
                    const value = typeof item === 'string' ? item : item?.id || String(item);
                    handleInputChange({ target: { name: 'status', value } });
                  }}
                  getItemKey={(it) => it.id}
                  getItemLabel={(it) => it.name}
                  placeholder={!isOriginator && isEditing ? t.yourStatus : t.status}
                  theme={theme}
                  language={language}
                  maxItems={8}
                  inputStyle={{
                    ...unifiedControlStyle(theme, language === 'ar'),
                    padding: screenSize.isMobile ? "12px 16px" : "16px 20px",
                    borderRadius: screenSize.isMobile ? "10px" : "14px",
                    width: "100%",
                    boxSizing: "border-box",
                    border: theme === "dark"
                      ? "2px solid rgba(255,255,255,0.12)"
                      : "2px solid rgba(0,0,0,0.08)",
                    background: theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
                  }}
                />
              </div>
            </div>
            {/* النوع والأولوية */}
            <div style={styles.formGroup || { marginBottom: screenSize.isMobile ? "16px" : "20px" }}>
              <div>
                <label style={styles.formLabel}>{t.eventType}</label>
                <div style={styles.formInputWrapper}>
                  <ReusableDropdown
                    items={eventTypes.filter((it) => it.id !== 'all')}
                    value={formData.type}
                    onSelect={(item) => {
                      const value = typeof item === 'string' ? item : item?.id || String(item);
                      handleEventTypeChange({ target: { name: 'type', value } });
                    }}
                    getItemKey={(it) => it.id}
                    getItemLabel={(it) => it.name}
                    placeholder={t.eventType}
                    theme={theme}
                    language={language}
                    maxItems={8}
                    disabled={!isOriginator && isEditing}
                    inputStyle={{
                      ...unifiedControlStyle(theme, language === 'ar'),
                      padding: screenSize.isMobile ? "12px 16px" : "16px 20px",
                      borderRadius: screenSize.isMobile ? "10px" : "14px",
                      width: "100%",
                      boxSizing: "border-box",
                      border: theme === "dark"
                        ? "2px solid rgba(255,255,255,0.12)"
                        : "2px solid rgba(0,0,0,0.08)",
                      background: theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
                    }}
                  />
                </div>
              </div>
            </div>











          </div>


          {/* Inline validation warning for date range */}
          {dateRangeInvalid && (
            <div
              style={{
                color: "#ef4444",
                fontSize: screenSize.isMobile ? 12 : 14,
                fontWeight: 600,
                marginTop: 8,
                padding: screenSize.isMobile ? "8px 12px" : "12px 16px",
                background: "rgba(239, 68, 68, 0.06)",
                borderRadius: screenSize.isMobile ? 8 : 12,
                border: "1px solid rgba(239, 68, 68, 0.12)",
                textAlign: language === "ar" ? "right" : "left",
              }}
            >
              {t.endDateEarlier}
            </div>
          )}


          {/* الموقع - Conditionally shown */}
          {eventConfig.showLocation && (
            <div
              style={styles.formGroup || { marginBottom: screenSize.isMobile ? "16px" : "20px" }}
            >
              <label style={styles.formLabel}>
                {eventType === "conference"
                  ? t.venue
                  : eventType === "meeting"
                    ? t.meetingLocation
                    : t.location}
              </label>
              <input
                name="location"
                value={formData.location}
                onChange={handleInputChange}
                style={{
                  ...styles.formInput,
                  ...unifiedControlStyle(theme, language === 'ar'),
                  background:
                    !isOriginator && isEditing
                      ? theme === "dark"
                        ? "rgba(255,255,255,0.06)"
                        : "rgba(255,255,255,0.5)"
                      : styles.formInput.background,
                }}
                placeholder={
                  eventType === "conference"
                    ? t.conferenceVenue
                    : eventType === "meeting"
                      ? t.meetingRoom
                      : t.locationDetails
                }
                disabled={!isOriginator && isEditing}
              />
            </div>
          )}

          {/* الحضور - Conditionally shown */}
          {eventConfig.showAttendees && (isOriginator || isEditing) && (
            <div
              style={styles.formGroup || { marginBottom: screenSize.isMobile ? "16px" : "20px" }}
            >
              <label style={styles.formLabel}>
                {!isOriginator && isEditing
                  ? t.eventAttendees
                  : `${t.attendees} (${formData.attendees
                    ? formData.attendees.split(",").filter((e) => e.trim())
                      .length
                    : 0
                  })`}
              </label>

              {isOriginator ? (
                <div style={{ position: "relative" }}>
                  <ReusableDropdown
                    items={employeeList.filter((emp) => {
                      const current = (formData.attendees || "")
                        .split(",")
                        .map((e) => e.trim().toLowerCase())
                        .filter(Boolean);
                      return emp.email && !current.includes(emp.email.toLowerCase());
                    })}
                    value={suggestionFilter}
                    onChange={(v) => {
                      setSuggestionFilter(v);
                      setShowSuggestions(!!v);
                    }}
                    onSelect={(item) => {
                      addEmployeeFromSuggestion(item);
                    }}
                    getItemKey={(it) => it.email}
                    getItemLabel={(it) => `${it.name} `}
                    placeholder={t.typeNameEmail}
                    theme={theme}
                    language={language}
                    maxItems={8}
                  />

                  {/* Add button removed per request; dropdown handles selections. */}
                </div>
              ) : (
                // عرض المدعوين للقراءة فقط
                <div
                  style={{
                    ...styles.formInput,
                    ...unifiedControlStyle(theme, language === 'ar'),
                    background: theme === "dark"
                      ? "rgba(255,255,255,0.06)"
                      : "rgba(255,255,255,0.5)",
                    color:
                      theme === "dark"
                        ? "rgba(255,255,255,0.7)"
                        : "rgba(26,26,26,0.7)",
                  }}
                >
                  {formData.originatorName && formData.originatorName !== t.unknownUser && (
                    <>
                      {t.organizer}: {getShortName(formData.originatorName, 2)} ({t.organizer})
                      {formData.attendees && formData.attendees.trim() && <br />}
                    </>
                  )}
                  {formData.attendees && formData.attendees.trim() && (
                    <>
                      {t.attendees}: {formData.attendees}
                    </>
                  )}
                </div>
              )}

              {/* عرض المدعوين كأقراص محسنة */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: screenSize.isMobile ? 6 : 8,
                  marginTop: 12,
                  flexDirection: language === "ar" ? "row-reverse" : "row",
                }}
              >
                {formData.originatorName && formData.originatorName !== t.unknownUser && (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: screenSize.isMobile ? 6 : 8,
                      padding: screenSize.isMobile ? "6px 10px" : "8px 14px",
                      borderRadius: 999,
                      fontSize: screenSize.isMobile ? 11 : 13,
                      fontWeight: 600,
                      background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                      color: "#fff",
                      border: "2px solid #2e7cba",
                      // boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
                      flexDirection: language === "ar" ? "row-reverse" : "row",
                    }}
                  >
                    <div
                      style={{
                        width: screenSize.isMobile ? 16 : 20,
                        height: screenSize.isMobile ? 16 : 20,
                        borderRadius: "50%",
                        background: "rgba(255,255,255,0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: screenSize.isMobile ? 8 : 10,
                        fontWeight: 700,
                      }}
                    >
                      {getEmployeeInitials({
                        name: formData.originatorName,
                        email: "",
                      })}
                    </div>
                    {getShortName(formData.originatorName, 2)} ({t.organizer})
                  </div>
                )}

                {/* أقراص المدعوين */}
                {(formData.attendees || "")
                  .split(",")
                  .map((email) => email.trim())
                  .filter((email) => email.length > 0)
                  .map((email, idx) => {
                    const employee = employeeList.find(
                      (emp) => emp.email.toLowerCase() === email.toLowerCase()
                    );
                    const exists = !!employee;

                    return (
                      <div
                        key={email + "-" + idx}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: screenSize.isMobile ? 6 : 8,
                          padding: screenSize.isMobile
                            ? "6px 10px"
                            : "8px 14px",
                          borderRadius: 999,
                          fontSize: screenSize.isMobile ? 11 : 13,
                          fontWeight: 600,
                          background: exists
                            ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
                            : "linear-gradient(135deg, #f59e0b, #d97706)",
                          color: "#fff",
                          border: exists
                            ? "2px solid #2e7cba"
                            : "2px solid #d97706",
                          cursor: isOriginator ? "pointer" : "default",
                          boxShadow: exists
                            ? "0 4px 12px rgba(59, 130, 246, 0.3)"
                            : "0 4px 12px rgba(245, 158, 11, 0.3)",
                          transition: "all 0.2s ease",
                          flexDirection: language === "ar" ? "row-reverse" : "row",
                        }}
                        title={
                          exists
                            ? `${employee.name} - ${employee.position} - ${employee.department}`
                            : (language === "ar" ? "بريد إلكتروني خارجي - غير موجود في قاعدة بيانات الموظفين" : "External email - not in employee database")
                        }
                        onClick={
                          isOriginator
                            ? () => {
                              const remaining = (formData.attendees || "")
                                .split(",")
                                .map((e) => e.trim())
                                .filter(
                                  (e) =>
                                    e.length > 0 &&
                                    e.toLowerCase() !== email.toLowerCase()
                                );
                              setFormData((prev) => ({
                                ...prev,
                                attendees: remaining.join(", "),
                              }));
                            }
                            : undefined
                        }
                      >
                        <div
                          style={{
                            width: screenSize.isMobile ? 16 : 20,
                            height: screenSize.isMobile ? 16 : 20,
                            borderRadius: "50%",
                            background: "rgba(255,255,255,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: screenSize.isMobile ? 8 : 10,
                            fontWeight: 700,
                          }}
                        >
                          {exists
                            ? getEmployeeInitials(employee)
                            : email[0].toUpperCase()}
                        </div>

                        <span
                          style={{
                            maxWidth: screenSize.isMobile ? 120 : 180,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {exists ? getShortName(employee.name, 2) : email}
                        </span>

                        {isOriginator && (
                          <div
                            style={{
                              width: screenSize.isMobile ? 14 : 16,
                              height: screenSize.isMobile ? 14 : 16,
                              borderRadius: "50%",
                              background: "rgba(255,255,255,0.2)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: screenSize.isMobile ? 10 : 12,
                              cursor: "pointer",
                            }}
                          >
                            ×
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>

              {/* عداد المدعوين والمعلومات */}
              <div
                style={{
                  fontSize: screenSize.isMobile ? 10 : 12,
                  color:
                    theme === "dark"
                      ? "rgba(255,255,255,0.6)"
                      : "rgba(26,26,26,0.5)",
                  marginTop: 8,
                  display: "flex",
                  flexDirection: screenSize.isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: screenSize.isMobile ? "flex-start" : "center",
                  gap: screenSize.isMobile ? 4 : 0,
                  textAlign: language === "ar" ? "right" : "left",
                }}
              >
                <span>
                  {formData.attendees
                    ? formData.attendees.split(",").filter((e) => e.trim())
                      .length
                    : 0}{" "}
                  {formData.attendees &&
                    formData.attendees.split(",").filter((e) => e.trim())
                      .length !== 1
                    ? t.attendeesPlural
                    : t.attendee}{" "}
                  {t.willReceiveInvitations}
                </span>
                {employeeList.length > 0 && (
                  <span style={{ fontStyle: "italic" }}>
                    {employeeList.length} {t.employeesAvailable}
                  </span>
                )}
              </div>
            </div>
          )}

          {/* التكرار - Conditionally shown */}
          {/* {eventConfig.showRecurrence && isOriginator && (
            <div
              style={styles.formGroup || { marginBottom: screenSize.isMobile ? "16px" : "20px" }}
            >
              <label style={styles.formLabel}>{t.recurrence}</label>
              <div style={{ minHeight: "48px", display: "flex", alignItems: "flex-start" }}>
                <ReusableDropdown
                  items={[
                    { id: '', name: t.noRecurrence },
                    { id: 'daily', name: t.daily },
                    { id: 'weekly', name: t.weekly },
                    { id: 'monthly', name: t.monthly },
                    { id: 'yearly', name: t.yearly },
                  ]}
                  value={formData.recurrenceRule}
                  onSelect={(item) => {
                    const value = typeof item === 'string' ? item : item?.id || String(item);
                    handleInputChange({ target: { name: 'recurrenceRule', value } });
                  }}
                  getItemKey={(it) => String(it.id)}
                  getItemLabel={(it) => it.name}
                  placeholder={t.recurrence}
                  theme={theme}
                  language={language}
                  maxItems={6}
                  inputStyle={{
                    ...unifiedControlStyle(theme, language === 'ar'),
                    //padding: isMobile ? "12px 48px 12px 16px" : "16px 48px 16px 20px",
                    //borderRadius: isMobile ? "10px" : "14px",
                    border: theme === "dark"
                      ? "2px solid rgba(255,255,255,0.12)"
                      : "2px solid rgba(0,0,0,0.08)",
                    background: theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
                  }}
                />
              </div>
            </div>
          )} */}
          {/* {eventConfig.showReminder && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: screenSize.isMobile ? "12px 16px" : "16px",
                borderRadius: screenSize.isMobile ? "10px" : "14px",
                background:
                  theme === "dark"
                    ? "rgba(255,255,255,0.03)"
                    : "rgba(0,0,0,0.02)",
                border:
                  theme === "dark"
                    ? "1px solid rgba(255,255,255,0.08)"
                    : "1px solid rgba(0,0,0,0.05)",
                marginBottom: screenSize.isMobile ? "16px" : "20px",
                flexDirection: language === "ar" ? "row-reverse" : "row",
              }}
            >
              <input
                type="checkbox"
                name="reminder"
                checked={!!formData.reminder}
                onChange={handleInputChange}
                style={{
                  width: "18px",
                  height: "18px",
                  accentColor: "#2e7cba",
                }}
                disabled={!isOriginator && isEditing}
              />
              <label
                style={{
                  fontSize: screenSize.isMobile ? "13px" : "14px",
                  color:
                    theme === "dark"
                      ? "rgba(255,255,255,0.8)"
                      : "rgba(26,26,26,0.7)",
                  fontWeight: "500",
                  textAlign: language === "ar" ? "right" : "left",
                }}
              >
                {!isOriginator && isEditing
                  ? t.emailRemindersEnabled
                  : `${t.enableReminders} ${eventType === "vacation"
                    ? (language === "ar" ? "الإجازة" : "vacation")
                    : (language === "ar" ? "الحدث" : "event")
                  } ${t.reminders}`}
              </label>
            </div>
          )} */}

          {errorMsg && (
            <div
              style={{
                color: "#ef4444",
                fontSize: screenSize.isMobile ? 12 : 14,
                fontWeight: 600,
                marginTop: 16,
                padding: screenSize.isMobile ? "8px 12px" : "12px 16px",
                background: "rgba(239, 68, 68, 0.06)",
                borderRadius: screenSize.isMobile ? 8 : 12,
                border: "1px solid rgba(239, 68, 68, 0.12)",
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexDirection: language === "ar" ? "row-reverse" : "row",
                textAlign: language === "ar" ? "right" : "left",
              }}
            >
              <AlertCircle size={16} />
              {errorMsg}
            </div>
          )}

          {/* الإجراءات */}
          <div style={styles.formActions}>
            {/* إجراءات مختلفة للمنظمين مقابل المدعوين */}
            {isOriginator && selectedEvent && (
              <button
                type="button"
                onClick={() => handleDelete(selectedEvent)}
                style={styles.actionButton("danger", "medium")}
                onMouseEnter={(e) => handleButtonHover(e, true, "danger")}
                onMouseLeave={(e) => handleButtonHover(e, false, "danger")}
              >
                <Trash2 size={16} /> {t.deleteEvent}
              </button>
            )}

            <button
              type="button"
              onClick={() => setShowEventModal(false)}
              style={styles.actionButton("default", "medium")}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
            >
              <X size={16} /> {!isOriginator && isEditing ? t.close : t.cancel}
            </button>

            {/* عرض زر الحفظ للمنظمين أو الأحداث الجديدة فقط */}
            {(isOriginator || !isEditing) && (
              <button
                type="submit"
                style={styles.actionButton("primary", "medium")}

              >
                <Check size={16} />
                {selectedEvent ? t.updateEvent : t.createEvent}
              </button>
            )}

            {/* المدعوون يمكنهم تحديث حالة RSVP */}

            {!isOriginator && isEditing && !getCurrentUserRSVPStatus(selectedEvent) && (
              <>
                <button
                  type="button"
                  onClick={() =>
                    handleStatusUpdate(selectedEvent.id, "accepted")
                  }
                  style={styles.actionButton("success", "medium")}
                  onMouseEnter={(e) => handleButtonHover(e, true, "success")}
                  onMouseLeave={(e) => handleButtonHover(e, false, "success")}
                >
                  <Check size={16} />
                  {t.accept}
                </button>

                <button
                  type="button"
                  onClick={() =>
                    handleStatusUpdate(selectedEvent.id, "declined")
                  }
                  style={styles.actionButton("danger", "medium")}
                  onMouseEnter={(e) => handleButtonHover(e, true, "danger")}
                  onMouseLeave={(e) => handleButtonHover(e, false, "danger")}
                >
                  <X size={16} />
                  {t.decline}
                </button>

                <button
                  type="button"
                  onClick={() =>
                    handleStatusUpdate(selectedEvent.id, "tentative")
                  }
                  style={styles.actionButton("warning", "medium")}
                  onMouseEnter={(e) => handleButtonHover(e, true, "warning")}
                  onMouseLeave={(e) => handleButtonHover(e, false, "warning")}
                >
                  <Clock size={16} />
                  {t.maybe}
                </button>

                <button
                  type="button"
                  onClick={() => handleStatusUpdate(selectedEvent.id, "going")}
                  style={styles.actionButton("primary", "medium")}
                  onMouseEnter={(e) => handleButtonHover(e, true, "primary")}
                  onMouseLeave={(e) => handleButtonHover(e, false, "primary")}
                >
                  <Users size={16} />
                  {t.going}
                </button>
              </>
            )}
          </div>
        </form>
      </>
    );
  };

  /**
   * نافذة التصدير المنبثقة
   */
  const ExportModal = () => {
    if (!showExportModal) return null;

    const exportOptions = [
      {
        id: "pdf",
        name: t.pdfReport,
        icon: FileText,
        description: t.formattedReport,
      },
      {
        id: "excel",
        name: t.excelFile,
        icon: Download,
        description: t.spreadsheetData,
      },
      {
        id: "ical",
        name: t.calendarFile,
        icon: CalendarIcon,
        description: t.importCalendars,
      },
    ];

    return (
      <div style={styles.modalOverlay}>
        <div style={styles.modalContainer}>
          <div style={styles.modalHeader}>
            <div style={styles.modalTitleSection}>
              <div style={styles.modalIcon}>
                <Download size={screenSize.isMobile ? 24 : 28} />
              </div>
              <div>
                <h2 style={styles.modalTitle}>{t.exportCalendar}</h2>
                <p style={styles.modalSubtitle}>
                  {t.chooseFormat}
                </p>
              </div>
            </div>
            <button
              onClick={() => setShowExportModal(false)}
              style={styles.closeButton}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
            >
              <X size={screenSize.isMobile ? 20 : 24} />
            </button>
          </div>

          <div style={styles.formContainer}>
            <div
              style={{ marginBottom: screenSize.isMobile ? "16px" : "24px" }}
            >
              <label style={styles.formLabel}>{t.exportFormat}</label>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: screenSize.isMobile
                    ? "1fr"
                    : "repeat(auto-fit, minmax(150px, 1fr))",
                  gap: screenSize.isMobile ? "12px" : "16px",
                  marginBottom: screenSize.isMobile ? "16px" : "24px",
                }}
              >
                {exportOptions.map((option) => (
                  <div
                    key={option.id}
                    style={{
                      padding: screenSize.isMobile ? "16px" : "20px",
                      borderRadius: screenSize.isMobile ? "12px" : "16px",
                      border:
                        exportFormat === option.id
                          ? "2px solid #2e7cba"
                          : theme === "dark"
                            ? "1px solid rgba(255,255,255,0.1)"
                            : "1px solid rgba(0,0,0,0.1)",
                      background:
                        exportFormat === option.id
                          ? "rgba(59, 130, 246, 0.1)"
                          : theme === "dark"
                            ? "rgba(255,255,255,0.02)"
                            : "rgba(255,255,255,0.5)",
                      cursor: "pointer",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => setExportFormat(option.id)}
                    onMouseEnter={(e) => handleCardHover(e, true)}
                    onMouseLeave={(e) => handleCardHover(e, false)}
                  >
                    <div
                      style={{
                        width: screenSize.isMobile ? "40px" : "48px",
                        height: screenSize.isMobile ? "40px" : "48px",
                        margin: "0 auto 12px",
                        borderRadius: screenSize.isMobile ? "10px" : "12px",
                        background: "rgba(59, 130, 246, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#2e7cba",
                      }}
                    >
                      <option.icon size={screenSize.isMobile ? 20 : 24} />
                    </div>
                    <div
                      style={{
                        fontSize: screenSize.isMobile ? "13px" : "14px",
                        fontWeight: "600",
                        color: theme === "dark" ? "#fff" : "#1a1a1a",
                        marginBottom: "4px",
                      }}
                    >
                      {option.name}
                    </div>
                    <div
                      style={{
                        fontSize: screenSize.isMobile ? "11px" : "12px",
                        color:
                          theme === "dark"
                            ? "rgba(255,255,255,0.6)"
                            : "rgba(26,26,26,0.5)",
                      }}
                    >
                      {option.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{ marginBottom: screenSize.isMobile ? "16px" : "24px" }}
            >
              <label style={styles.formLabel}>{t.dateRange}</label>
              <select
                value={exportDateRange}
                onChange={(e) => setExportDateRange(e.target.value)}
                style={styles.formSelect}
              >
                <option value="this_week">{t.thisWeekRange}</option>
                <option value="this_month">{t.thisMonthRange}</option>
                <option value="last_month">{t.lastMonth}</option>
                <option value="this_quarter">{t.thisQuarter}</option>
                <option value="this_year">{t.thisYear}</option>
                <option value="all">{t.allEventsRange}</option>
              </select>
            </div>

            <div style={styles.formActions}>
              <button
                onClick={() => setShowExportModal(false)}
                style={styles.actionButton("default")}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                {t.cancel}
              </button>
              <button
                onClick={() => {
                  // هنا يمكن إضافة منطق التصدير
                  console.log("Exporting...", {
                    format: exportFormat,
                    range: exportDateRange,
                  });
                  setShowExportModal(false);
                }}
                disabled={loading}
                style={styles.actionButton("primary")}
                onMouseEnter={(e) => handleButtonHover(e, true, "primary")}
                onMouseLeave={(e) => handleButtonHover(e, false, "primary")}
              >
                <Download size={16} />
                {loading ? t.exporting : t.export}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /**
   * نافذة المشاركة المنبثقة
   */
  const ShareModal = () => {
    if (!showShareModal) return null;

    const shareOptions = [
      // { id: "download_image", name: language === "ar" ? "تنزيل كصورة" : "Download Image", icon: Download, color: "#6b7280" },
      // { id: "download_pdf", name: language === "ar" ? "تنزيل كـ PDF" : "Download PDF", icon: FileText, color: "#111" },
      { id: "facebook", name: t.facebook, icon: Facebook, color: "#2e7cba" },
      // { id: "twitter", name: t.twitter, icon: Twitter, color: "#1da1f2" },
      { id: "linkedin", name: t.linkedin, icon: Linkedin, color: "#0077b5" },
      {
        id: "whatsapp",
        name: t.whatsApp,
        icon: MessageCircle,
        color: "#25d366",
      },
      {
        id: "whatsapp_share",
        name: language === "ar" ? "مشاركة واتساب (صورة)" : "WhatsApp (Image)",
        icon: MessageCircle,
        color: "#25d366",
      },
      { id: "email", name: t.email, icon: Mail, color: "#ea4335" },
    ];

    const shareToSocialMedia = (platform) => {
      const url = encodeURIComponent(window.location.href);
      const text = encodeURIComponent(
        language === "ar"
          ? `تحقق من تقويمي لـ ${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`
          : `Check out my calendar for ${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`
      );

      const urls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        twitter: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
        whatsapp: `https://wa.me/?text=${text} ${url}`,
        email: `mailto:?subject=${text}&body=${url}`,
      };

      if (platform === "download_image") {
        exportCalendar(false);
        setShowShareModal(false);
        return;
      }
      if (platform === "download_pdf") {
        exportCalendar(true);
        setShowShareModal(false);
        return;
      }

      if (platform === "whatsapp_share") {
        // attempt to share image directly using Web Share API (files)
        (async () => {
          try {
            const canvas = await createCalendarCanvas();
            const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
            const fileName = `Calendar-${monthNames[currentDate.getMonth()]}-${currentDate.getFullYear()}.png`;
            const file = new File([blob], fileName, { type: "image/png" });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              await navigator.share({ files: [file], title: fileName, text: "Shared calendar" });
            } else if (navigator.share) {
              // try fallback (text + dataURL) - many browsers won't allow large data URLs in share
              const url = canvas.toDataURL("image/png");
              await navigator.share({ title: fileName, text: language === "ar" ? "مشاركة التقويم" : "Sharing calendar", url });
            } else {
              // fallback to whatsapp web with message (user will need to attach image manually)
              const text = encodeURIComponent(
                language === "ar"
                  ? `ألقِ نظرة على تقويمي ${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`
                  : `Check my calendar ${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`
              );
              window.open(`https://wa.me/?text=${text}`, "_blank");
            }
          } catch (err) {
            console.error("WhatsApp share failed", err);
            sendNotification({ title: language === "ar" ? "خطأ" : "Error", message: language === "ar" ? "فشل المشاركة عبر واتساب" : "Failed to share via WhatsApp", type: "error" });
          }
        })();
        setShowShareModal(false);
        return;
      }

      if (urls[platform]) {
        window.open(urls[platform], "_blank", "width=600,height=400");
      }
    };

    const copyCalendarLink = () => {
      navigator.clipboard.writeText(window.location.href);
      setErrorMsg("");
      sendNotification({
        title: t.linkCopied,
        message: t.linkCopiedMessage,
        type: "success",
      });
    };

    return (
      <div style={styles.modalOverlay}>
        <div style={styles.modalContainer}>
          <div style={styles.modalHeader}>
            <div style={styles.modalTitleSection}>
              <div style={styles.modalIcon}>
                <Share2 size={screenSize.isMobile ? 24 : 28} />
              </div>
              <div>
                <h2 style={styles.modalTitle}>{t.shareCalendar}</h2>
                <p style={styles.modalSubtitle}>
                  {t.shareWith}
                </p>
              </div>
            </div>
            <button
              onClick={() => setShowShareModal(false)}
              style={styles.closeButton}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
            >
              <X size={screenSize.isMobile ? 20 : 24} />
            </button>
          </div>

          <div style={styles.formContainer}>
            <div
              style={{ marginBottom: screenSize.isMobile ? "16px" : "24px" }}
            >
              <label style={styles.formLabel}>{t.shareVia}</label>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: screenSize.isMobile
                    ? "repeat(2, 1fr)"
                    : "repeat(auto-fit, minmax(100px, 1fr))",
                  gap: screenSize.isMobile ? "12px" : "16px",
                  marginBottom: screenSize.isMobile ? "16px" : "24px",
                }}
              >
                {shareOptions.map((option) => (
                  <div
                    key={option.id}
                    style={{
                      padding: screenSize.isMobile ? "16px 12px" : "20px 16px",
                      borderRadius: screenSize.isMobile ? "12px" : "16px",
                      border:
                        theme === "dark"
                          ? "1px solid rgba(255,255,255,0.1)"
                          : "1px solid rgba(0,0,0,0.1)",
                      background:
                        theme === "dark"
                          ? "rgba(255,255,255,0.02)"
                          : "rgba(255,255,255,0.5)",
                      cursor: "pointer",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onClick={() => shareToSocialMedia(option.id)}
                  //onMouseEnter={(e) => handleCardHover(e, true)}
                  //onMouseLeave={(e) => handleCardHover(e, false)}
                  >
                    <div
                      style={{
                        width: screenSize.isMobile ? "32px" : "40px",
                        height: screenSize.isMobile ? "32px" : "40px",
                        borderRadius: screenSize.isMobile ? "10px" : "12px",
                        background: `${option.color}20`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: option.color,
                      }}
                    >
                      <option.icon size={screenSize.isMobile ? 16 : 20} />
                    </div>
                    <div
                      style={{
                        fontSize: screenSize.isMobile ? "11px" : "12px",
                        fontWeight: "600",
                        color: theme === "dark" ? "#fff" : "#1a1a1a",
                      }}
                    >
                      {option.name}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{ marginBottom: screenSize.isMobile ? "16px" : "24px" }}
            >
              <label style={styles.formLabel}>{t.copyLink}</label>
              <div style={{ display: "flex", gap: "12px", flexDirection: language === "ar" ? "row-reverse" : "row" }}>
                <input
                  type="text"
                  value={window.location.href}
                  readOnly
                  style={styles.formInput}
                />
                <button
                  onClick={copyCalendarLink}
                  style={styles.actionButton("default")}
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  <Copy size={16} />
                </button>
              </div>
            </div>

            <div style={styles.formActions}>
              <button
                onClick={() => setShowShareModal(false)}
                style={styles.actionButton("default")}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                {t.close}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ===============================================
  // MAIN RENDER - العرض الرئيسي
  // ===============================================
  return (
    <div >
      {/* شاشة التحميل */}
      {loading && (
        <div style={styles.loadingOverlay}>
          <div style={styles.loadingSpinner}></div>
        </div>
      )}

      {/* النوافذ المنبثقة */}
      <ExportModal />
      <ShareModal />

      {/* الرأس المحسن */}
      <div style={styles.headerSection}>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "linear-gradient(90deg, #2e7cba, #2e7cba, #2e7cba)",
          }}
        ></div>
        <div>
          <div style={styles.headerLeft}>
            <div style={styles.headerText}>
              <h1 style={styles.headerTitle}>{t.calendar}</h1>
              {/* <p style={styles.headerSubtitle}>
                {                                              }
              </p> */}
              <div style={{
                ...styles.headerActions,
                marginLeft: language === 'ar' ? 0 : 'auto',
                marginRight: language === 'ar' ? 'auto' : 0,
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <button
                  style={styles.actionButton("success", "medium")}
                  onClick={() => openCreateModal()}
                >
                  <Plus size={18} />
                  {screenSize.isMobile ? t.new : t.newEvent}
                </button>

                <button
                  style={{ ...styles.actionButton("default", "medium"), display: 'flex', alignItems: 'center' }}
                  onClick={() => exportCalendar(false)}
                  title={language === "ar" ? "تنزيل كصورة" : "Download Image"}
                >
                  <Download size={16} />
                  {screenSize.isMobile ? (language === "ar" ? "صورة" : "Img") : (language === "ar" ? "تنزيل صورة" : "Download Image")}
                </button>

                <button
                  style={{ ...styles.actionButton("default", "medium"), display: 'flex', alignItems: 'center' }}
                  onClick={() => exportCalendar(true)}
                  title={language === "ar" ? "تنزيل كـ PDF" : "Download PDF"}
                >
                  <FileText size={16} />
                  {screenSize.isMobile ? "PDF" : (language === "ar" ? "تنزيل PDF" : "Download PDF")}
                </button>

                <button
                  style={styles.actionButton("default", "medium")}
                  onClick={() => setShowShareModal(true)}
                >
                  <Share2 size={18} />
                  {screenSize.isMobile ? t.share : t.share}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div style={styles.statsGrid}>
        {enhancedStats.map((stat, index) => (
          <div
            key={index}
            style={styles.statCard(stat.color, index)}
            onMouseEnter={(e) => handleCardHover(e, true)}
            onMouseLeave={(e) => handleCardHover(e, false)}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "4px",
                background: `linear-gradient(90deg, ${stat.color}, ${stat.color}99)`,
              }}
            ></div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: screenSize.isMobile ? "12px" : "20px",
                flexDirection: language === "ar" ? "row" : "row",
              }}
            >
              <div
                style={{
                  width: screenSize.isMobile ? "40px" : "56px",
                  height: screenSize.isMobile ? "40px" : "56px",
                  borderRadius: screenSize.isMobile ? "12px" : "16px",
                  background: `${stat.color}20`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: stat.color,
                  boxShadow: `0 8px 20px ${stat.color}30`,
                }}
              >
                <stat.icon size={screenSize.isMobile ? 20 : 28} />
              </div>
              <div
              //   style={{
              //     display: "flex",
              //     alignItems: "center",
              //     gap: "6px",
              //     fontSize: screenSize.isMobile ? "10px" : "12px",
              //     fontWeight: "700",
              //     color: stat.isPositive ? "#2e7cba" : "#ef4444",
              //     background: stat.isPositive
              //       ? "rgba(16, 185, 129, 0.15)"
              //       : "rgba(239, 68, 68, 0.15)",
              //     padding: screenSize.isMobile ? "4px 8px" : "6px 12px",
              //     borderRadius: "20px",
              //     backdropFilter: "blur(10px)",
              //     flexDirection: language === "ar" ? "row-reverse" : "row",
              //   }}
              >
                {/* {stat.isPositive ? (
                  <TrendingUp size={screenSize.isMobile ? 10 : 14} />
                ) : (
                  <TrendingDown size={screenSize.isMobile ? 10 : 14} />
                )} */}
                {/* {stat.change} */}
              </div>
            </div>
            <div style={styles.statValue}>{stat.value}</div>
            <div style={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>

      {/* لوحة التحكم المحسنة */}
      {/* لوحة التحكم مع To-Do List */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',  // ⬅️ التعديل
        gap: '24px',

        marginBottom: '10px',
      }}>

        {/* To-Do List - جديد */}
        {/* <div style={styles.controlPanel}>
          <TodoListComponent
            todos={todos}
            setTodos={setTodos}
            newTodoText={newTodoText}
            setNewTodoText={setNewTodoText}
            todoFilter={todoFilter}
            setTodoFilter={setTodoFilter}
            todoCategory={todoCategory}
            setTodoCategory={setTodoCategory}
            theme={theme}
            language={language}
            t={t}
            styles={styles}
            screenSize={screenSize}
          />
        </div> */}

        {/* Calendar Controls */}
        {/* <div style={styles.controlPanel}>
          <div
            style={{
              display: "flex",
              flexDirection: screenSize.isMobile ? "column" : "row",
              justifyContent: "space-between",
              alignItems: screenSize.isMobile ? language === "ar" ? "flex-end" : "flex-start" : "center",
              gap: screenSize.isMobile ? "16px" : "20px",
              marginBottom: screenSize.isMobile ? "16px" : "28px",
              paddingBottom: screenSize.isMobile ? "16px" : "20px",
              borderBottom:
                theme === "dark"
                  ? "1px solid rgba(255,255,255,0.1)"
                  : "1px solid rgba(0,0,0,0.08)",
            }}
          >
            <h3
              style={{
                fontSize: screenSize.isMobile ? "18px" : "24px",
                fontWeight: "700",
                color: theme === "dark" ? "#fff" : "#1a1a1a",
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexDirection: language === "ar" ? "row-reverse" : "row",
              }}
            >
              <Settings size={screenSize.isMobile ? 18 : 20} /> {t.calendarControls}
            </h3>
          </div>

          <div style={styles.controlRow}>
            <div style={styles.searchContainer}>
              <div
                style={{
                  position: "absolute",
                  left: language === "ar" ? "auto" : "20px",
                  right: language === "ar" ? "20px" : "auto",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color:
                    theme === "dark"
                      ? "rgba(255,255,255,0.4)"
                      : "rgba(26,26,26,0.4)",
                  zIndex: 1,
                }}
              >
                <Search size={screenSize.isMobile ? 16 : 20} />
              </div>
              <input
                type="text"
                placeholder={t.searchEvents}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.searchInput}
              />
            </div>

            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              style={{
                ...styles.formSelect,
                minWidth: screenSize.isMobile ? "100%" : "180px",
              }}
            >
              {eventTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
        </div> */}
        {/* الأحداث القادمة */}
        <div style={styles.sidebarCard}>
          <h3 style={styles.sidebarTitle}>
            <Clock size={20} /> {t.upcomingEvents}
          </h3>

          {loading ? (
            <div
              style={{
                textAlign: "center",
                padding: screenSize.isMobile ? "20px 0" : "40px 0",
              }}
            >
              <div style={styles.loadingSpinner}></div>
            </div>
          ) : filteredUpcomingEvents.length === 0 ? (
            <div style={styles.emptyState}>
              <CalendarIcon style={styles.emptyIcon} />
              <h4 style={styles.emptyTitle}>{t.noUpcomingEvents}</h4>
              <p style={styles.emptyDescription}>
                {t.calendarClear}
              </p>
            </div>
          ) : (
            filteredUpcomingEvents.map((ev) => (
              <div
                key={ev.id}
                style={{
                  padding: screenSize.isMobile ? "16px" : "20px",
                  borderRadius: screenSize.isMobile ? "12px" : "16px",
                  background:
                    theme === "dark"
                      ? "rgba(255,255,255,0.03)"
                      : "rgba(255,255,255,0.7)",
                  border:
                    theme === "dark"
                      ? "1px solid rgba(255,255,255,0.08)"
                      : "1px solid rgba(0,0,0,0.06)",
                  marginBottom: screenSize.isMobile ? "12px" : "16px",
                  cursor: "pointer",
                  transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  backdropFilter: "blur(15px)",
                }}
                onClick={() => openEditModal(ev)}
              // onMouseEnter={(e) => handleCardHover(e, true)}
              // onMouseLeave={(e) => handleCardHover(e, false)}
              >
                <div
                  style={{
                    fontSize: screenSize.isMobile ? "14px" : "16px",
                    fontWeight: "700",
                    color: theme === "dark" ? "#fff" : "#1a1a1a",
                    marginBottom: "8px",
                    lineHeight: "1.3",
                    textAlign: language === "ar" ? "right" : "left",
                  }}
                >
                  {ev.title}
                </div>
                <div
                  style={{
                    fontSize: screenSize.isMobile ? "12px" : "13px",
                    color:
                      theme === "dark"
                        ? "rgba(255,255,255,0.7)"
                        : "rgba(26,26,26,0.6)",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginBottom: "4px",
                    fontWeight: "500",
                    flexDirection: language === "ar" ? "row-reverse" : "row",
                    textAlign: language === "ar" ? "right" : "left",
                  }}
                >
                  <Clock size={14} />
                  {new Date(
                    `${ev.date}T00:00:00`
                  ).toLocaleDateString(language === "ar" ? "ar-EG" : "en-US")} {language === "ar" ? "في" : "at"} {ev.time}
                </div>
                {ev.location && (
                  <div
                    style={{
                      fontSize: screenSize.isMobile ? "11px" : "12px",
                      color:
                        theme === "dark"
                          ? "rgba(255,255,255,0.6)"
                          : "rgba(26,26,26,0.5)",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      marginBottom: "4px",
                      fontWeight: "500",
                      flexDirection: language === "ar" ? "row-reverse" : "row",
                      textAlign: language === "ar" ? "right" : "left",
                    }}
                  >
                    <MapPin size={12} /> {ev.location}
                  </div>
                )}
                {ev.priority === "urgent" && (
                  <div
                    style={{
                      color: "#ef4444",
                      fontSize: screenSize.isMobile ? "11px" : "12px",
                      fontWeight: "600",
                      marginTop: "4px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      flexDirection: language === "ar" ? "row-reverse" : "row",
                      textAlign: language === "ar" ? "right" : "left",
                    }}
                  >
                    <AlertCircle size={12} />
                    {t.urgent}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
        {/* To-Do List - جديد */}
        <div style={styles.controlPanel}>
          <SimpleTodoList
            todos={todos}
            setTodos={setTodos}
            newTodoText={newTodoText}
            setNewTodoText={setNewTodoText}
            todoFilter={todoFilter}
            setTodoFilter={setTodoFilter}
            todoCategory={todoCategory}
            setTodoCategory={setTodoCategory}
            theme={theme}
            language={language}
            t={t}
            styles={styles}
            screenSize={screenSize}
            addTodo={addTodo}
            deleteTodo={deleteTodo}
            toggleTodo={toggleTodo}
          />

        </div>

      </div>


      {/* <div
        style={{
          display: "flex",
          flexDirection: screenSize.isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: screenSize.isMobile ? language === "ar" ? "flex-end" : "flex-start" : "center",
          gap: screenSize.isMobile ? "16px" : "20px",
          marginBottom: screenSize.isMobile ? "16px" : "28px",
          paddingBottom: screenSize.isMobile ? "16px" : "20px",
          borderBottom:
            theme === "dark"
              ? "1px solid rgba(255,255,255,0.1)"
              : "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <h3
          style={{
            fontSize: screenSize.isMobile ? "18px" : "24px",
            fontWeight: "700",
            color: theme === "dark" ? "#fff" : "#1a1a1a",
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexDirection: language === "ar" ? "row-reverse" : "row",
          }}
        >
          <Settings size={screenSize.isMobile ? 18 : 20} /> {t.calendarControls}
        </h3>
      </div>

      <div style={styles.controlRow}>
        <div style={styles.searchContainer}>
          <div
            style={{
              position: "absolute",
              left: language === "ar" ? "auto" : "20px",
              right: language === "ar" ? "20px" : "auto",
              top: "50%",
              transform: "translateY(-50%)",
              color:
                theme === "dark"
                  ? "rgba(255,255,255,0.4)"
                  : "rgba(26,26,26,0.4)",
              zIndex: 1,
            }}
          >
            <Search size={screenSize.isMobile ? 16 : 20} />
          </div>
          <input
            type="text"
            placeholder={t.searchEvents}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>

        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          style={{
            ...styles.formSelect,
            minWidth: screenSize.isMobile ? "100%" : "180px",
          }}
        >
          {eventTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div> */}

      {/* حاوية التقويم المحسنة */}
      <div style={styles.calendarContainer}>
        {/* التقويم الرئيسي */}
        <div id="calendar-export" style={styles.calendarMain}>
          {/* رأس التقويم */}
          <div style={styles.calendarHeader}>
            <div style={styles.calendarNavigation}>
              <button
                style={styles.navButton}
                onClick={handlePrevMonth}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                <ChevronLeft size={screenSize.isMobile ? 20 : 24} />
              </button>

              <div style={styles.currentMonth}>
                {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
              </div>

              <button
                style={styles.navButton}
                onClick={handleNextMonth}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                <ChevronRight size={screenSize.isMobile ? 20 : 24} />
              </button>
            </div>
          </div>

          {/* شبكة التقويم */}
          <div style={styles.calendarGrid}>
            {/* رؤوس الأيام */}
            {dayNames.map((day) => (
              <div key={day} style={styles.calendarDayHeader}>
                {screenSize.isMobile ? day.slice(0, language === "ar" ? 3 : 2) : day}
              </div>
            ))}

            {/* أيام الشهر */}
            {getDaysInMonth(currentDate).map((dayObj, index) => {
              const date = dayObj.date ? new Date(dayObj.date) : null;

              if (!date) {
                return <div key={index} style={styles.calendarDay(dayObj)} />;
              }

              const dateString = date.toISOString().split("T")[0];
              const isSelected = selectedDates.has(dateString);
              const isToday = date.toDateString() === new Date().toDateString();
              const isVacation = vacationDates.has(dateString);
              const dayEvents = getEventsForDate(date);

              const isInRange =
                dateRangeStart &&
                dateRangeEnd &&
                date >= dateRangeStart &&
                date <= dateRangeEnd;

              return (
                <div
                  key={index}
                  style={styles.calendarDay(
                    dayObj,
                    isSelected,
                    isToday,
                    isVacation,
                    isInRange
                  )}
                  onClick={() => {
                    handleDateClick(date);
                    openCreateModal(date);
                  }}
                >
                  {/* رقم اليوم */}
                  <div
                    style={styles.calendarDayNumber(
                      isSelected,
                      isToday,
                      isVacation,
                      dayEvents.length > 0
                    )}
                  >
                    {date.getDate()}
                  </div>

                  {/* الأحداث */}
                  {dayEvents
                    .slice(0, screenSize.isMobile ? 2 : 3)
                    .map((event) => (
                      <button
                        key={event.id}
                        type="button"
                        className="event-pill"
                        style={{
                          ...styles.eventItem(event),
                          border: "none",
                          outline: "none",
                          background: `linear-gradient(90deg, ${event.color}CC 60%, ${event.color}99 100%)`,
                          borderRadius: "999px",
                          boxShadow: `0 2px 12px 0 ${event.color}33`,
                          padding: screenSize.isMobile ? "4px 8px" : "8px 18px",
                          fontSize: screenSize.isMobile ? "10px" : "13px",
                          fontWeight: 700,
                          minHeight: screenSize.isMobile ? "20px" : "32px",
                          display: "flex",
                          alignItems: "center",
                          gap: screenSize.isMobile ? "4px" : "8px",
                          transition:
                            "all 0.18s cubic-bezier(0.25,0.46,0.45,0.94)",
                          cursor: "pointer",
                          marginBottom: screenSize.isMobile ? "2px" : "6px",
                          marginTop: "2px",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          color: "#fff",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openEditModal(event);
                        }}
                        aria-label={`${t.viewEvent} ${event.title}`}
                        aria-haspopup="dialog"
                        onMouseEnter={(e) =>
                        (e.currentTarget.style.filter =
                          "brightness(1.08) drop-shadow(0 2px 8px #0002)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.filter = "")
                        }
                      >
                        <span
                          style={{
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: screenSize.isMobile ? "80px" : "120px",
                            verticalAlign: "middle",
                          }}
                        >
                          {event.title.length > (screenSize.isMobile ? 15 : 20)
                            ? event.title.substring(
                              0,
                              screenSize.isMobile ? 15 : 20
                            ) + "..."
                            : event.title}
                        </span>
                      </button>
                    ))}
                  {dayEvents.length > (screenSize.isMobile ? 2 : 3) && (
                    <div
                      style={{
                        fontSize: screenSize.isMobile ? "9px" : "10px",
                        color: "#888",
                        textAlign: "center",
                        marginTop: "2px",
                      }}
                    >
                      +{dayEvents.length - (screenSize.isMobile ? 2 : 3)} {t.more}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* الشريط الجانبي المحسن - يظهر في الأعلى على الموبايل */}
        <div style={styles.sidebar}>
          {/* زر إضافة حدث */}
          {/* <button
            style={styles.actionButton("primary", "large")}
            onClick={() => openCreateModal()}
            onMouseEnter={(e) => handleButtonHover(e, true, "primary")}
            onMouseLeave={(e) => handleButtonHover(e, false, "primary")}
          >
            <Plus size={screenSize.isMobile ? 20 : 24} />
            {screenSize.isMobile ? t.newEvent : t.newEvent}
          </button> */}

          {/* أنواع الأحداث */}
          {/* أنواع الأحداث */}
          <div style={styles.sidebarCard1}>
            {eventTypes.map((type) => (
              <div
                key={type.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: screenSize.isMobile ? "12px" : "26px",
                  marginBottom: screenSize.isMobile ? "8px" : "42px",
                  // ⬅️ الخط يظهر بس لو الـ type هو "event" (Plus icon)
                  paddingBottom: type.id === "event" ? (screenSize.isMobile ? "20px" : "32px") : 0,
                  borderBottom: type.id === "event"
                    ? (theme === "dark"
                      ? "1px solid rgba(255,255,255,0.1)"
                      : "1px solid rgba(0,0,0,0.08)")
                    : "none",
                  flexDirection: language === "ar" ? "row-reverse" : "row",
                  cursor: "pointer",
                }}
                onClick={() => {
                  // ⬅️ لو الـ type هو "event" (Plus icon)، افتح نافذة إنشاء حدث جديد
                  if (type.id === "event") {
                    openCreateModal();
                  } else {
                    // ⬅️ لو أي type تاني، فلتر الأحداث
                    setFilterType(type.id);
                  }
                }}
              >
                <div
                  style={{
                    width: screenSize.isMobile ? "32px" : "40px",
                    height: screenSize.isMobile ? "32px" : "40px",
                    borderRadius: screenSize.isMobile ? "10px" : "12px",
                    background: `${type.color}20`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: type.color,
                    flexShrink: 0,
                  }}
                >
                  <type.icon size={screenSize.isMobile ? 16 : 20} />
                </div>
                <div style={{ flex: 1, textAlign: language === "ar" ? "right" : "left" }}>
                  <div
                  // style={{
                  //   fontSize: screenSize.isMobile ? "13px" : "15px",
                  //   fontWeight: "700",
                  //   color: theme === "dark" ? "#fff" : "#1a1a1a",
                  //   marginBottom: "4px",
                  // }}
                  >
                    {/* {type.name} */}
                  </div>
                  {/* <div
                    style={{
                      fontSize: screenSize.isMobile ? "11px" : "12px",
                      color:
                        theme === "dark"
                          ? "rgba(255,255,255,0.6)"
                          : "rgba(26,26,26,0.5)",
                      fontWeight: "500",
                    }}
                  >
                    {eventCounts[type.id] || 0} {language === "ar" ? "حدث" : "events"}
                  </div> */}
                  {/* {!screenSize.isMobile && (
                    <div
                      style={{
                        fontSize: "11px",
                        color:
                          theme === "dark"
                            ? "rgba(255,255,255,0.5)"
                            : "rgba(26,26,26,0.4)",
                        marginTop: "2px",
                        lineHeight: "1.3",
                      }}
                    >
                      {type.description}
                    </div>
                  )} */}
                </div>
              </div>
            ))}
          </div>

          {/* إجراءات سريعة */}
          {/* <div style={styles.sidebarCard}>
            <h3 style={styles.sidebarTitle}>
              <Zap size={20} /> {t.quickActions}
            </h3>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: screenSize.isMobile ? "8px" : "12px",
              }}
            >
              <button
                style={styles.actionButton("default", "medium")}
                onClick={() => setShowShareModal(true)}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                <Share2 size={16} />
                {t.shareCalendar}
              </button>
            </div>
          </div> */}
        </div>
      </div>

      {/* النافذة المنبثقة المحسنة للأحداث */}
      {
        showEventModal && (
          <div
            style={styles.modalOverlay}
            onClick={() => setShowEventModal(false)}
          >
            <div
              style={styles.modalContainer}
              onClick={(e) => e.stopPropagation()}
            >
              {renderModalContent()}
            </div>
          </div>
        )
      }

      {/* إضافة أنماط CSS للرسوم المتحركة */}
      <style jsx>{`
       div[style*="overflowY: auto"]::-webkit-scrollbar {
    display: none;
  } 
select option {
    background: ${theme === "dark" ? "rgba(2, 38, 97, 0.9)" : "#1715247e"} !important;
    color: #fff !important;
    padding: 12px;
    
  }
  
  select option:hover {
    background: ${theme === "dark" ? "rgba(2, 38, 97, 0.9)" : "#3a39457e"} !important;
  }1
  /* إخفاء scrollbar مع الحفاظ على القدرة على السكرول */
  .modal-form-container {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }
  
  .modal-form-container::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .event-pill:hover {
          transform: translateY(-2px) scale(1.05);
          filter: brightness(1.1) drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
        }

        /* تحسينات للتمرير على الشاشات الصغيرة */
        @media (max-width: 768px) {
          body {
            -webkit-overflow-scrolling: touch;
          }

          input,
          select,
          textarea {
            font-size: 16px; /* منع التكبير على iOS */
          }
        }

        /* تحسينات للشاشات الكبيرة */
        @media (min-width: 1400px) {
          .calendar-container {
            max-width: 1600px;
            margin: 0 auto;
          }
        }
      `}</style>
    </div >
  );
};

export default Calendar;